var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/config/index.ts
var SLOT_CONFIG_NETWORK = {
  mainnet: { zeroTime: 1596059091e3, zeroSlot: 4492800, slotDuration: 1e3 },
  preview: { zeroTime: 1666656e6, zeroSlot: 0, slotDuration: 1e3 },
  preprod: { zeroTime: 16540416e5 + 1728e6, zeroSlot: 86400, slotDuration: 1e3 },
  custom: { zeroTime: 0, zeroSlot: 0, slotDuration: 0 }
};
var TTL = 900;
var DERIVATION_SCHEME = {
  purpose: {
    hdwallet: 1852,
    multisig: 1854,
    minting: 1855,
    voting: 1694
  },
  coinType: {
    ada: 1815
  },
  account: {
    first: 0
  },
  role: {
    payment: 0,
    change: 1,
    stake: 2
  },
  index: {
    first: 0
  }
};
var DEFAULT_ACCOUNT_DERIVATION_PATH = [
  DERIVATION_SCHEME.purpose.hdwallet,
  DERIVATION_SCHEME.coinType.ada,
  DERIVATION_SCHEME.account.first
];
var DEFAULT_ADDRESS_DERIVATION_PATH = [
  DERIVATION_SCHEME.role.payment,
  DERIVATION_SCHEME.index.first
];
var DEFAULT_PROTOCOL_PARAMETERS = {
  minFeeA: 44,
  minFeeB: 155381,
  maxTxSize: 16384,
  maxValSize: 5e3,
  keyDeposit: 2000000n,
  poolDeposit: 500000000n,
  priceMem: 0.0577,
  priceStep: 721e-7,
  maxTxExMem: 14000000n,
  maxTxExSteps: 10000000000n,
  coinsPerUtxoByte: 4310n,
  collateralPercentage: 150,
  maxCollateralInputs: 3,
  minFeeRefScriptCostPerByte: 15,
  costModels: {
    PlutusV1: [
      205665,
      812,
      1,
      1,
      1e3,
      571,
      0,
      1,
      1e3,
      24177,
      4,
      1,
      1e3,
      32,
      117366,
      10475,
      4,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      100,
      100,
      23e3,
      100,
      19537,
      32,
      175354,
      32,
      46417,
      4,
      221973,
      511,
      0,
      1,
      89141,
      32,
      497525,
      14068,
      4,
      2,
      196500,
      453240,
      220,
      0,
      1,
      1,
      1e3,
      28662,
      4,
      2,
      245e3,
      216773,
      62,
      1,
      1060367,
      12586,
      1,
      208512,
      421,
      1,
      187e3,
      1e3,
      52998,
      1,
      80436,
      32,
      43249,
      32,
      1e3,
      32,
      80556,
      1,
      57667,
      4,
      1e3,
      10,
      197145,
      156,
      1,
      197145,
      156,
      1,
      204924,
      473,
      1,
      208896,
      511,
      1,
      52467,
      32,
      64832,
      32,
      65493,
      32,
      22558,
      32,
      16563,
      32,
      76511,
      32,
      196500,
      453240,
      220,
      0,
      1,
      1,
      69522,
      11687,
      0,
      1,
      60091,
      32,
      196500,
      453240,
      220,
      0,
      1,
      1,
      196500,
      453240,
      220,
      0,
      1,
      1,
      806990,
      30482,
      4,
      1927926,
      82523,
      4,
      265318,
      0,
      4,
      0,
      85931,
      32,
      205665,
      812,
      1,
      1,
      41182,
      32,
      212342,
      32,
      31220,
      32,
      32696,
      32,
      43357,
      32,
      32247,
      32,
      38314,
      32,
      57996947,
      18975,
      10
    ],
    PlutusV2: [
      205665,
      812,
      1,
      1,
      1e3,
      571,
      0,
      1,
      1e3,
      24177,
      4,
      1,
      1e3,
      32,
      117366,
      10475,
      4,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      23e3,
      100,
      100,
      100,
      23e3,
      100,
      19537,
      32,
      175354,
      32,
      46417,
      4,
      221973,
      511,
      0,
      1,
      89141,
      32,
      497525,
      14068,
      4,
      2,
      196500,
      453240,
      220,
      0,
      1,
      1,
      1e3,
      28662,
      4,
      2,
      245e3,
      216773,
      62,
      1,
      1060367,
      12586,
      1,
      208512,
      421,
      1,
      187e3,
      1e3,
      52998,
      1,
      80436,
      32,
      43249,
      32,
      1e3,
      32,
      80556,
      1,
      57667,
      4,
      1e3,
      10,
      197145,
      156,
      1,
      197145,
      156,
      1,
      204924,
      473,
      1,
      208896,
      511,
      1,
      52467,
      32,
      64832,
      32,
      65493,
      32,
      22558,
      32,
      16563,
      32,
      76511,
      32,
      196500,
      453240,
      220,
      0,
      1,
      1,
      69522,
      11687,
      0,
      1,
      60091,
      32,
      196500,
      453240,
      220,
      0,
      1,
      1,
      196500,
      453240,
      220,
      0,
      1,
      1,
      1159724,
      392670,
      0,
      2,
      806990,
      30482,
      4,
      1927926,
      82523,
      4,
      265318,
      0,
      4,
      0,
      85931,
      32,
      205665,
      812,
      1,
      1,
      41182,
      32,
      212342,
      32,
      31220,
      32,
      32696,
      32,
      43357,
      32,
      32247,
      32,
      38314,
      32,
      35892428,
      10,
      57996947,
      18975,
      10,
      38887044,
      32947,
      10
    ],
    PlutusV3: [
      100788,
      420,
      1,
      1,
      1e3,
      173,
      0,
      1,
      1e3,
      59957,
      4,
      1,
      11183,
      32,
      201305,
      8356,
      4,
      16e3,
      100,
      16e3,
      100,
      16e3,
      100,
      16e3,
      100,
      16e3,
      100,
      16e3,
      100,
      100,
      100,
      16e3,
      100,
      94375,
      32,
      132994,
      32,
      61462,
      4,
      72010,
      178,
      0,
      1,
      22151,
      32,
      91189,
      769,
      4,
      2,
      85848,
      123203,
      7305,
      -900,
      1716,
      549,
      57,
      85848,
      0,
      1,
      1,
      1e3,
      42921,
      4,
      2,
      24548,
      29498,
      38,
      1,
      898148,
      27279,
      1,
      51775,
      558,
      1,
      39184,
      1e3,
      60594,
      1,
      141895,
      32,
      83150,
      32,
      15299,
      32,
      76049,
      1,
      13169,
      4,
      22100,
      10,
      28999,
      74,
      1,
      28999,
      74,
      1,
      43285,
      552,
      1,
      44749,
      541,
      1,
      33852,
      32,
      68246,
      32,
      72362,
      32,
      7243,
      32,
      7391,
      32,
      11546,
      32,
      85848,
      123203,
      7305,
      -900,
      1716,
      549,
      57,
      85848,
      0,
      1,
      90434,
      519,
      0,
      1,
      74433,
      32,
      85848,
      123203,
      7305,
      -900,
      1716,
      549,
      57,
      85848,
      0,
      1,
      1,
      85848,
      123203,
      7305,
      -900,
      1716,
      549,
      57,
      85848,
      0,
      1,
      955506,
      213312,
      0,
      2,
      270652,
      22588,
      4,
      1457325,
      64566,
      4,
      20467,
      1,
      4,
      0,
      141992,
      32,
      100788,
      420,
      1,
      1,
      81663,
      32,
      59498,
      32,
      20142,
      32,
      24588,
      32,
      20744,
      32,
      25933,
      32,
      24623,
      32,
      43053543,
      10,
      53384111,
      14333,
      10,
      43574283,
      26308,
      10,
      16e3,
      100,
      16e3,
      100,
      962335,
      18,
      2780678,
      6,
      442008,
      1,
      52538055,
      3756,
      18,
      267929,
      18,
      76433006,
      8868,
      18,
      52948122,
      18,
      1995836,
      36,
      3227919,
      12,
      901022,
      1,
      166917843,
      4307,
      36,
      284546,
      36,
      158221314,
      26549,
      36,
      74698472,
      36,
      333849714,
      1,
      254006273,
      72,
      2174038,
      72,
      2261318,
      64571,
      4,
      207616,
      8310,
      4,
      1293828,
      28716,
      63,
      0,
      1,
      1006041,
      43623,
      251,
      0,
      1,
      100181,
      726,
      719,
      0,
      1,
      100181,
      726,
      719,
      0,
      1,
      100181,
      726,
      719,
      0,
      1,
      107878,
      680,
      0,
      1,
      95336,
      1,
      281145,
      18848,
      0,
      1,
      180194,
      159,
      1,
      1,
      158519,
      8942,
      0,
      1,
      159378,
      8813,
      0,
      1,
      107490,
      3298,
      1,
      106057,
      655,
      1,
      1964219,
      24520,
      3
    ]
  }
};

// src/core/txFinalizer.ts
var TxFinalizer = class {
  cw3;
  queue = [];
  __tx;
  __witnessBuilder;
  constructor(cw3, tx) {
    this.cw3 = cw3;
    this.__tx = this.cw3.CML.Transaction.from_cbor_hex(tx);
    this.__witnessBuilder = this.cw3.CML.TransactionWitnessSetBuilder.new();
  }
  /**
   * Sign TX with private key
   * @param verificationKey Private key to sign with
   * @returns TxFinalizer instance
   */
  signWithVrfKey = (verificationKey) => {
    this.queue.push(async () => {
      const vkey = this.cw3.CML.PrivateKey.from_bech32(verificationKey);
      this.__witnessBuilder.add_vkey(
        this.cw3.CML.make_vkey_witness(this.cw3.CML.hash_transaction(this.__tx.body()), vkey)
      );
    });
    return this;
  };
  /**
   * Sign TX with account
   * @param account Account to sign with
   * @param password Password to decode xprv key (optional)
   * @returns TxFinalizer instance
   */
  signWithAccount = (account, password) => {
    this.queue.push(async () => {
      if (account.__config.type === "xprv") {
        if (account.__config.xprvKeyIsEncoded && !password)
          throw new Error("Password is required to sign with xprv encoded account");
        const xprvKey = account.__config.xprvKeyIsEncoded ? account.decodeXprvKey(password) : account.__config.xprvKey;
        const paymentVerificationKey = this.cw3.utils.keys.xprvToVrfKey(
          xprvKey,
          account.__config.accountPath,
          account.__config.addressPath
        );
        const paymentKey = this.cw3.CML.PrivateKey.from_bech32(paymentVerificationKey);
        const paymentKeyHash = paymentKey.to_public().hash().to_hex();
        const stakingVerificationKey = this.cw3.utils.keys.xprvToVrfKey(xprvKey, account.__config.accountPath, [2, 0]);
        const stakingKey = this.cw3.CML.PrivateKey.from_bech32(stakingVerificationKey);
        const stakingKeyHash = stakingKey.to_public().hash().to_hex();
        const foundHashes = this.cw3.utils.tx.discoverOwnUsedTxKeyHashes(
          this.__tx,
          [stakingKeyHash, paymentKeyHash],
          account.__state.utxos
        );
        if (foundHashes.includes(paymentKeyHash)) {
          this.__witnessBuilder.add_vkey(
            this.cw3.CML.make_vkey_witness(this.cw3.CML.hash_transaction(this.__tx.body()), paymentKey)
          );
        }
        if (foundHashes.includes(stakingKeyHash)) {
          this.__witnessBuilder.add_vkey(
            this.cw3.CML.make_vkey_witness(this.cw3.CML.hash_transaction(this.__tx.body()), stakingKey)
          );
        }
      }
      if (account.__config.type === "connector") {
        const witnessSetHex = await account.__config.connector.signTx(this.__tx.to_cbor_hex());
        const witnessSet = this.cw3.CML.TransactionWitnessSet.from_cbor_hex(witnessSetHex);
        this.__witnessBuilder.add_existing(witnessSet);
      }
      if (account.__config.type === "ledger") {
        throw new Error("Ledger account signing is not implemented yet");
      }
      if (account.__config.type === "trezor") {
        throw new Error("Trezor account signing is not implemented yet");
      }
      if (account.__config.type === "xpub") {
        throw new Error("Can't sign TX with xpub account type. Use signWithVrfKey() method instead");
      }
    });
    return this;
  };
  /**
   * Apply all methods and return TxFinalizer instance
   * @returns TxFinalizer instance
   */
  apply = async () => {
    this.__witnessBuilder.add_existing(this.__tx.witness_set());
    for (const task of this.queue) {
      await task();
    }
    this.__tx = this.cw3.CML.Transaction.new(
      this.__tx.body(),
      this.__witnessBuilder.build(),
      true,
      this.__tx.auxiliary_data()
    );
    return this;
  };
  /**
   * Apply all methods and return TX in JSON format
   * @returns TX in JSON format
   */
  applyAndToJson = async () => {
    await this.apply();
    return {
      tx: this.__tx.to_cbor_hex(),
      hash: this.cw3.CML.hash_transaction(this.__tx.body()).to_hex(),
      json: this.__tx.to_js_value()
    };
  };
  /**
   * Apply all methods and submit transaction to blockchain
   * @returns Transaction hash
   */
  applyAndSubmit = async () => {
    await this.apply();
    return await this.cw3.provider.submitTx(this.__tx.to_cbor_hex());
  };
  /**
   * Apply all methods and submit TX with observing
   * @param checkInterval Check interval in ms
   * @param maxTime Max time to wait in ms
   * @returns Transaction status (boolean)
   */
  applyAndSubmitAndObserve = async (checkInterval = 3e3, maxTime) => {
    await this.apply();
    return await this.cw3.provider.submitAndObserveTx(this.__tx.to_cbor_hex(), checkInterval, maxTime);
  };
};

// src/core/txBuilder.ts
var TxBuilder = class {
  cw3;
  protocolParams;
  changeAddress;
  scripts = /* @__PURE__ */ new Map();
  queue = [];
  inputs = /* @__PURE__ */ new Map();
  readInputs = /* @__PURE__ */ new Map();
  collectInputs = /* @__PURE__ */ new Map();
  remoteProtocolParams = false;
  remoteTxEvaluate = false;
  coinSelection = 2;
  // Default: LargestFirstMultiAsset
  __txBuilder;
  constructor(cw3) {
    this.cw3 = cw3;
  }
  /** Attach script to transaction builder for using in next operations
   * @param script Script to attach
   * @returns TxBuilder instance
   */
  attachScript = (script) => {
    const scriptHash = this.cw3.utils.script.scriptToScriptHash(script);
    this.scripts.set(scriptHash, script);
    return this;
  };
  /**
   * Add UTXOs to read referenced data from
   * @param utxos UTXOs to read from
   * @returns TxBuilder instance
   */
  readFrom = (utxos) => {
    this.queue.push(async () => {
      for (const utxoUnresolved of utxos) {
        const utxo = await this.cw3.provider.resolveUtxoDatumAndScript(utxoUnresolved);
        if (utxo.script) {
          this.scripts.set(utxo.scriptHash, utxo.script);
        }
        this.readInputs.set(`${utxo.index.toString()}@${utxo.transaction.id}`, utxo);
        const input = this.cw3.utils.tx.utxoToCore(utxo);
        this.__txBuilder.add_reference_input(input);
      }
    });
    return this;
  };
  /**
   * Add script UTXOs to spend from
   * @param utxos UTXOs to collect from
   * @param redeemer Redeemer to use (optional)
   * @returns TxBuilder instance
   */
  collectFrom = (utxos, redeemer) => {
    this.queue.push(async () => {
      for (const utxoUnresolved of utxos) {
        const utxo = await this.cw3.provider.resolveUtxoDatumAndScript(utxoUnresolved);
        const { paymentCred } = this.cw3.utils.address.getCredentials(utxo.address);
        const script = this.scripts.get(paymentCred.hash);
        if (!script) {
          throw new Error(
            "Script is required for collectFrom() method. Attach script with attachScript() or readFrom() method"
          );
        }
        this.collectInputs.set(`${utxo.index.toString()}@${utxo.transaction.id}`, utxo);
        const coreUtxo = this.cw3.utils.tx.utxoToCore(utxo);
        const inputBuilder = this.cw3.CML.SingleInputBuilder.from_transaction_unspent_output(coreUtxo);
        switch (script.language) {
          case "Native":
            this.__txBuilder.add_input(
              inputBuilder.native_script(
                this.cw3.CML.NativeScript.from_cbor_hex(script.script),
                this.cw3.CML.NativeScriptWitnessInfo.assume_signature_count()
              )
            );
            break;
          case "PlutusV1":
            if (!redeemer) {
              throw new Error(
                "Redeemer is required for Plutus scripts. Use Data.void() if script doesn't require a redeemer"
              );
            }
            this.__txBuilder.add_input(
              inputBuilder.plutus_script(
                this.cw3.utils.script.partialPlutusWitness(
                  this.cw3.utils.script.scriptToPlutusScript(script),
                  redeemer
                ),
                this.cw3.CML.Ed25519KeyHashList.new(),
                this.cw3.CML.PlutusData.from_cbor_hex(utxo.datum)
              )
            );
            break;
          case "PlutusV2":
            if (!redeemer) {
              throw new Error(
                "Redeemer is required for Plutus scripts. Use Data.void() if script doesn't require a redeemer"
              );
            }
            this.__txBuilder.add_input(
              inputBuilder.plutus_script_inline_datum(
                this.cw3.utils.script.partialPlutusWitness(
                  this.cw3.utils.script.scriptToPlutusScript(script),
                  redeemer
                ),
                this.cw3.CML.Ed25519KeyHashList.new()
              )
            );
            break;
          case "PlutusV3":
            throw new Error("PlutusV3 scripts are not supported yet");
        }
      }
    });
    return this;
  };
  /**
   * Add UTXOs to spend from
   * @param utxos UTXOs to spend from
   * @returns TxBuilder instance
   */
  addInputs = (utxos) => {
    this.queue.push(async () => {
      for (const utxo of utxos) {
        this.inputs.set(`${utxo.index.toString()}@${utxo.transaction.id}`, utxo);
        const coreUtxo = this.cw3.utils.tx.utxoToCore(utxo);
        const inputBuilder = this.cw3.CML.SingleInputBuilder.from_transaction_unspent_output(coreUtxo);
        this.__txBuilder.add_input(inputBuilder.payment_key());
      }
    });
    return this;
  };
  /**
   * Main method to pay to address with/without data
   * @param output Output to pay to
   * @param datum Datum to attach
   * @param script Script to attach (optional)
   * @returns TxBuilder instance
   * @throws Error if script is not provided with hash datum type
   */
  payTo = (output, datum, script) => {
    this.queue.push(async () => {
      const outputBuilder = this.cw3.utils.tx.outputToTransactionOutputBuilder(output, datum, script);
      const outputBuilderResult = output.value > 0n ? outputBuilder.next().with_value(this.cw3.utils.tx.assetsToValue(output.value, output.assets)).build() : outputBuilder.next().with_asset_and_min_required_coin(
        this.cw3.utils.tx.assetsToValue(output.value, output.assets).multi_asset(),
        this.protocolParams.coinsPerUtxoByte
      ).build();
      this.__txBuilder.add_output(outputBuilderResult);
    });
    return this;
  };
  /**
   * Add Output with data to pay to contract with address check
   * @param output Output to pay to
   * @param datum Datum to attach
   * @param script Script to attach
   * @returns TxBuilder instance
   * @throws Error if address is not script type
   */
  payToContract = (output, datum, script) => {
    const { paymentCred } = this.cw3.utils.address.getCredentials(output.address);
    if (!paymentCred || paymentCred.type !== "script") {
      throw new Error("Invalid address for contract");
    }
    this.payTo(output, datum, script);
    return this;
  };
  /**
   * Add Outputs to pay to addresses
   * @param outputs Outputs to pay to
   * @param datum Datum to attach (optional)
   * @param script Script to attach (optional)
   * @returns TxBuilder instance
   */
  addOutputs = (outputs, datum, script) => {
    for (const output of outputs) {
      this.payTo(output, datum, script);
    }
    return this;
  };
  /**
   * Set transaction validity start interval
   * @param unixTime Unix timestamp
   * @returns TxBuilder instance
   */
  validFrom = (unixTime) => {
    this.queue.push(async () => {
      const slot = this.cw3.utils.time.unixTimeToSlot(unixTime);
      this.__txBuilder.set_validity_start_interval(BigInt(slot));
    });
    return this;
  };
  /**
   * Set transaction validity end interval by Unix timestamp
   * @param unixTime Unix timestamp
   * @returns TxBuilder instance
   */
  validTo = (unixTime) => {
    this.queue.push(async () => {
      const slot = this.cw3.utils.time.unixTimeToSlot(unixTime);
      this.__txBuilder.set_ttl(BigInt(slot));
    });
    return this;
  };
  /**
   * Set transaction validity end interval (TTL) in slots from now
   * @param slotsOffset Slots offset
   * @returns TxBuilder instance
   */
  setTtl = (slotsOffset) => {
    this.queue.push(async () => {
      const slot = this.cw3.utils.time.unixTimeToSlot(Date.now() + slotsOffset * 1e3);
      this.__txBuilder.set_ttl(BigInt(slot));
    });
    return this;
  };
  /**
   * Set change address
   * @param address Change address
   * @returns TxBuilder instance
   */
  setChangeAddress = (address) => {
    this.changeAddress = address;
    return this;
  };
  /**
   * Add Required Signer by address
   * @param address Address of required signer
   * @returns TxBuilder instance
   */
  addRequiredSignerByAddress = (address) => {
    this.queue.push(() => {
      const { paymentCred, stakingCred, type } = this.cw3.utils.address.getCredentials(address);
      if (!paymentCred && !stakingCred) {
        throw new Error("Invalid address for required signer");
      }
      const credential = type == "reward" ? stakingCred : paymentCred;
      if (credential.type === "script") {
        throw new Error("Only key hash (not script) is allowed for required signer");
      }
      this.__txBuilder.add_required_signer(this.cw3.CML.Ed25519KeyHash.from_hex(credential.hash));
    });
    return this;
  };
  /**
   * Add Required Signer by key hash
   * @param keyHash Key hash of required signer
   * @returns TxBuilder instance
   */
  addRequiredSignerByKey = (keyHash) => {
    this.queue.push(() => {
      this.__txBuilder.add_required_signer(this.cw3.CML.Ed25519KeyHash.from_hex(keyHash));
    });
    return this;
  };
  /**
   * Add minting of assets
   * @param assets Assets to mint
   * @param redeemer Redeemer to use (optional)
   * @returns TxBuilder instance
   */
  addMint = (assets, redeemer) => {
    this.queue.push(async () => {
      const policyId = assets[0].policyId;
      const mintAssets = this.cw3.CML.MapAssetNameToNonZeroInt64.new();
      for (const asset of assets) {
        if (asset.policyId !== policyId) throw new Error("All assets must have the same policyId");
        mintAssets.insert(this.cw3.CML.AssetName.from_str(asset.assetName || ""), asset.quantity);
      }
      const script = this.scripts.get(policyId);
      if (!script) {
        throw new Error(
          "Script is required for addMint() method. Attach script with attachScript() or readFrom() method"
        );
      }
      const mintBuilder = this.cw3.CML.SingleMintBuilder.new(mintAssets);
      switch (script.language) {
        case "Native":
          this.__txBuilder.add_mint(
            mintBuilder.native_script(
              this.cw3.CML.NativeScript.from_cbor_hex(script.script),
              this.cw3.CML.NativeScriptWitnessInfo.assume_signature_count()
            )
          );
          break;
        case "PlutusV1":
        case "PlutusV2":
          if (!redeemer) {
            throw new Error(
              "Redeemer is required for Plutus scripts. Use Data.void() if script doesn't require a redeemer"
            );
          }
          this.__txBuilder.add_mint(
            mintBuilder.plutus_script(
              this.cw3.utils.script.partialPlutusWitness(this.cw3.utils.script.scriptToPlutusScript(script), redeemer),
              this.cw3.CML.Ed25519KeyHashList.new()
            )
          );
          break;
        case "PlutusV3":
          throw new Error("PlutusV3 scripts are not supported yet");
      }
    });
    return this;
  };
  /**
   * Add metadata as string to transaction
   * @param label Metadata label
   * @param metadata Metadata to attach
   * @returns TxBuilder instance
   */
  addMetadataString = (label, metadata) => {
    this.queue.push(async () => {
      const metadatum = this.cw3.CML.TransactionMetadatum.new_text(JSON.stringify(metadata));
      const metadataBuilder = this.cw3.CML.Metadata.new();
      metadataBuilder.set(BigInt(label), metadatum);
      const aux = this.cw3.CML.AuxiliaryData.new();
      aux.add_metadata(metadataBuilder);
      this.__txBuilder.add_auxiliary_data(aux);
    });
    return this;
  };
  /**
   * Add metadata as JSON (with conversion) to transaction
   * @param label Metadata label
   * @param metadata Metadata to attach
   * @param conversion Conversion type (optional, 0: default, 1: detailed, 2: more detailed)
   * @returns TxBuilder instance
   */
  addMetadataJson = (label, metadata, conversion = 0) => {
    this.queue.push(async () => {
      const metadatum = this.cw3.CML.encode_json_str_to_metadatum(JSON.stringify(metadata), conversion);
      const metadataBuilder = this.cw3.CML.Metadata.new();
      metadataBuilder.set(BigInt(label), metadatum);
      const aux = this.cw3.CML.AuxiliaryData.new();
      aux.add_metadata(metadataBuilder);
      this.__txBuilder.add_auxiliary_data(aux);
    });
    return this;
  };
  /**
   * Add withdrawal of rewards
   * @param rewardAddress Reward address to withdraw from
   * @param amount Amount to withdraw
   * @param script Script to attach (optional)
   * @param redeemer Redeemer to use (optional)
   * @returns TxBuilder instance
   */
  withdrawRewards = (rewardAddress, amount, redeemer) => {
    this.queue.push(async () => {
      const { stakingCred } = this.cw3.utils.address.getCredentials(rewardAddress);
      if (!stakingCred) throw new Error("Invalid address for rewards withdrawal (no staking credential)");
      const withdrawBuilder = this.cw3.CML.SingleWithdrawalBuilder.new(
        this.cw3.CML.RewardAddress.from_address(this.cw3.CML.Address.from_bech32(rewardAddress)),
        amount
      );
      switch (stakingCred.type) {
        case "key": {
          this.__txBuilder.add_withdrawal(withdrawBuilder.payment_key());
          break;
        }
        case "script": {
          const script = this.scripts.get(stakingCred.hash);
          if (!script) {
            throw new Error(
              "Script is required for withdrawRewards() method. Attach script with attachScript() or readFrom() method"
            );
          }
          switch (script.language) {
            case "Native":
              this.__txBuilder.add_withdrawal(
                withdrawBuilder.native_script(
                  this.cw3.CML.NativeScript.from_cbor_hex(script.script),
                  this.cw3.CML.NativeScriptWitnessInfo.assume_signature_count()
                )
              );
            case "PlutusV1":
            case "PlutusV2":
              if (!redeemer) {
                throw new Error(
                  "Redeemer is required for Plutus scripts. Use Data.void() if script doesn't require a redeemer"
                );
              }
              this.__txBuilder.add_withdrawal(
                withdrawBuilder.plutus_script(
                  this.cw3.utils.script.partialPlutusWitness(
                    this.cw3.utils.script.scriptToPlutusScript(script),
                    redeemer
                  ),
                  this.cw3.CML.Ed25519KeyHashList.new()
                )
              );
              break;
            case "PlutusV3":
              throw new Error("PlutusV3 scripts are not supported yet");
          }
          break;
        }
      }
    });
    return this;
  };
  /**
   * Delegate to pool
   * @param rewardAddress Reward address to delegate from
   * @param poolId Pool ID to delegate to
   * @param script Script to attach (optional)
   * @param redeemer Redeemer to use (optional)
   * @returns TxBuilder instance
   */
  delegateTo = (rewardAddress, poolId, redeemer) => {
    this.queue.push(async () => {
      const { stakingCred } = this.cw3.utils.address.getCredentials(rewardAddress);
      if (!stakingCred) throw new Error("Invalid address for rewards delegation (no staking credential)");
      switch (stakingCred.type) {
        case "key": {
          const credential = this.cw3.CML.Credential.new_pub_key(this.cw3.CML.Ed25519KeyHash.from_hex(stakingCred.hash));
          const certificateBuilder = this.cw3.CML.SingleCertificateBuilder.new(
            this.cw3.CML.Certificate.new_stake_delegation(credential, this.cw3.CML.Ed25519KeyHash.from_bech32(poolId))
          );
          this.__txBuilder.add_cert(certificateBuilder.payment_key());
          break;
        }
        case "script": {
          const script = this.scripts.get(stakingCred.hash);
          if (!script) {
            throw new Error(
              "Script is required for delegateTo() method. Attach script with attachScript() or readFrom() method"
            );
          }
          const credential = this.cw3.CML.Credential.new_script(this.cw3.CML.ScriptHash.from_hex(stakingCred.hash));
          const certificateBuilder = this.cw3.CML.SingleCertificateBuilder.new(
            this.cw3.CML.Certificate.new_stake_delegation(credential, this.cw3.CML.Ed25519KeyHash.from_bech32(poolId))
          );
          switch (script.language) {
            case "Native":
              this.__txBuilder.add_cert(
                certificateBuilder.native_script(
                  this.cw3.CML.NativeScript.from_cbor_hex(script.script),
                  this.cw3.CML.NativeScriptWitnessInfo.assume_signature_count()
                )
              );
            case "PlutusV1":
            case "PlutusV2":
              if (!redeemer) {
                throw new Error(
                  "Redeemer is required for Plutus scripts. Use Data.void() if script doesn't require a redeemer"
                );
              }
              this.__txBuilder.add_cert(
                certificateBuilder.plutus_script(
                  this.cw3.utils.script.partialPlutusWitness(
                    this.cw3.utils.script.scriptToPlutusScript(script),
                    redeemer
                  ),
                  this.cw3.CML.Ed25519KeyHashList.new()
                )
              );
              break;
            case "PlutusV3":
              throw new Error("PlutusV3 scripts are not supported yet");
          }
          break;
        }
      }
    });
    return this;
  };
  /**
   * Register stake address
   * @param rewardAddress Reward address to register
   * @returns TxBuilder instance
   */
  registerStake = (rewardAddress) => {
    this.queue.push(async () => {
      const { stakingCred } = this.cw3.utils.address.getCredentials(rewardAddress);
      if (!stakingCred) throw new Error("Invalid address for rewards withdrawal (no staking credential)");
      const credential = stakingCred.type === "key" ? this.cw3.CML.Credential.new_pub_key(this.cw3.CML.Ed25519KeyHash.from_hex(stakingCred.hash)) : this.cw3.CML.Credential.new_script(this.cw3.CML.ScriptHash.from_hex(stakingCred.hash));
      const certificateBuilder = this.cw3.CML.SingleCertificateBuilder.new(
        this.cw3.CML.Certificate.new_stake_registration(credential)
      );
      this.__txBuilder.add_cert(certificateBuilder.skip_witness());
    });
    return this;
  };
  /**
   * Deregister stake address
   * @param rewardAddress Reward address to deregister
   * @param script Script to attach (optional)
   * @param redeemer Redeemer to use (optional)
   * @returns TxBuilder instance
   */
  deregisterStake = (rewardAddress, redeemer) => {
    this.queue.push(async () => {
      const { stakingCred } = this.cw3.utils.address.getCredentials(rewardAddress);
      if (!stakingCred) throw new Error("Invalid address for rewards deregistration (no staking credential)");
      switch (stakingCred.type) {
        case "key": {
          const credential = this.cw3.CML.Credential.new_pub_key(this.cw3.CML.Ed25519KeyHash.from_hex(stakingCred.hash));
          const certificateBuilder = this.cw3.CML.SingleCertificateBuilder.new(
            this.cw3.CML.Certificate.new_stake_deregistration(credential)
          );
          this.__txBuilder.add_cert(certificateBuilder.payment_key());
          break;
        }
        case "script": {
          const script = this.scripts.get(stakingCred.hash);
          if (!script) {
            throw new Error(
              "Script is required for delegateTo() method. Attach script with attachScript() or readFrom() method"
            );
          }
          const credential = this.cw3.CML.Credential.new_script(this.cw3.CML.ScriptHash.from_hex(stakingCred.hash));
          const certificateBuilder = this.cw3.CML.SingleCertificateBuilder.new(
            this.cw3.CML.Certificate.new_stake_deregistration(credential)
          );
          switch (script.language) {
            case "Native":
              this.__txBuilder.add_cert(
                certificateBuilder.native_script(
                  this.cw3.CML.NativeScript.from_cbor_hex(script.script),
                  this.cw3.CML.NativeScriptWitnessInfo.assume_signature_count()
                )
              );
            case "PlutusV1":
            case "PlutusV2":
              if (!redeemer) {
                throw new Error(
                  "Redeemer is required for Plutus scripts. Use Data.void() if script doesn't require a redeemer"
                );
              }
              this.__txBuilder.add_cert(
                certificateBuilder.plutus_script(
                  this.cw3.utils.script.partialPlutusWitness(
                    this.cw3.utils.script.scriptToPlutusScript(script),
                    redeemer
                  ),
                  this.cw3.CML.Ed25519KeyHashList.new()
                )
              );
              break;
            case "PlutusV3":
              throw new Error("PlutusV3 scripts are not supported yet");
          }
        }
      }
    });
    return this;
  };
  /**
   * Fetch protocol parameters from remote on TX build
   * @param remoteProtocolParams Fetch protocol parameters from remote
   * @returns TxBuilder instance
   */
  withRemoteProtocolParams = (remoteProtocolParams) => {
    this.remoteProtocolParams = remoteProtocolParams;
    return this;
  };
  /**
   * Evaluate TX execution cost remotely
   * @param remoteTxEvaluate Evaluate TX execution cost remotely
   * @returns TxBuilder instance
   */
  withRemoteTxEvaluate = (remoteTxEvaluate) => {
    this.remoteTxEvaluate = remoteTxEvaluate;
    return this;
  };
  /**
   * Set coin selection strategy
   *
   * -1: Include all inputs
   *
   * 0: LargestFirst: Performs CIP2's Largest First ada-only selection. Will error if outputs contain non-ADA assets
   *
   * 1: RandomImprove: Performs CIP2's Random Improve ada-only selection. Will error if outputs contain non-ADA assets
   *
   * 2: LargestFirstMultiAsset: Same as LargestFirst, but before adding ADA, will insert by largest-first for each asset type
   *
   * 3: RandomImproveMultiAsset: Same as RandomImprove, but before adding ADA, will insert by random-improve for each asset type
   *
   * @param strategy Coin selection strategy
   * @returns TxBuilder instance
   */
  setCoinSelection = (strategy) => {
    this.coinSelection = strategy;
    return this;
  };
  /**
   * Apply all methods and return TxFinalizer instance
   * @returns TxFinalizer instance
   */
  apply = async () => {
    if (!this.changeAddress) {
      throw new Error("Change address is required. Use setChangeAddress() method to set it");
    }
    if (!this.__txBuilder) {
      this.protocolParams = this.remoteProtocolParams ? await this.cw3.provider.getProtocolParameters() : this.cw3.__config.protocolParams;
      this.__txBuilder = this.cw3.utils.tx.getTxBuilder(this.protocolParams);
      this.__txBuilder.set_network_id(
        this.cw3.__config.network.type === "mainnet" ? this.cw3.CML.NetworkId.mainnet() : this.cw3.CML.NetworkId.testnet()
      );
      this.__txBuilder.set_ttl(BigInt(this.cw3.utils.time.unixTimeToSlot(Date.now() + TTL * 1e3)));
    }
    for (const task of this.queue) {
      await task();
    }
    if (this.__txBuilder.build_for_evaluation(
      this.cw3.CML.ChangeSelectionAlgo.Default,
      this.cw3.CML.Address.from_bech32(this.changeAddress)
    ).draft_tx().witness_set().redeemers()) {
      const collateral = [...this.inputs.values()].find((utxo) => utxo.value > 5e6);
      if (!collateral) throw new Error("Suitable collateral > 5 ADA not found");
      this.__txBuilder.add_collateral(
        this.cw3.CML.SingleInputBuilder.from_transaction_unspent_output(
          this.cw3.utils.tx.utxoToCore(collateral)
        ).payment_key()
      );
      this.__txBuilder.set_collateral_return(
        this.cw3.CML.TransactionOutputBuilder.new().with_address(this.cw3.CML.Address.from_bech32(this.changeAddress)).next().with_value(this.cw3.utils.tx.assetsToValue(collateral.value - BigInt(3e6), collateral.assets)).build().output()
      );
    }
    if (this.coinSelection !== -1) this.__txBuilder.select_utxos(this.coinSelection);
    const draftTx = this.__txBuilder.build_for_evaluation(
      this.cw3.CML.ChangeSelectionAlgo.Default,
      this.cw3.CML.Address.from_bech32(this.changeAddress)
    ).draft_tx();
    const draftTxRedeemers = draftTx.witness_set().redeemers();
    if (draftTxRedeemers) {
      if (!this.remoteTxEvaluate) {
        const costModels = this.cw3.utils.tx.createCostModels(this.protocolParams.costModels);
        const slotConfig = this.cw3.__config.slotConfig;
        const zeroRedeemers = this.cw3.CML.LegacyRedeemerList.new();
        for (let i = 0; i < draftTxRedeemers.as_arr_legacy_redeemer().len(); i++) {
          const redeemer = draftTxRedeemers.as_arr_legacy_redeemer().get(i);
          const zeroRedeemer = this.cw3.CML.LegacyRedeemer.new(
            redeemer.tag(),
            redeemer.index(),
            redeemer.data(),
            this.cw3.CML.ExUnits.new(0n, 0n)
          );
          zeroRedeemers.add(zeroRedeemer);
        }
        const draftTxWitnesses = draftTx.witness_set();
        draftTxWitnesses.set_redeemers(this.cw3.CML.Redeemers.new_arr_legacy_redeemer(zeroRedeemers));
        const newTx = this.cw3.CML.Transaction.new(draftTx.body(), draftTxWitnesses, true, draftTx.auxiliary_data());
        const allInputs = [...this.inputs.values(), ...this.readInputs.values(), ...this.collectInputs.values()];
        const inputs = allInputs.map((utxo) => this.cw3.utils.tx.utxoToTransactionInput(utxo).to_cbor_bytes());
        const outputs = allInputs.map((utxo) => this.cw3.utils.tx.utxoToTransactionOutput(utxo).to_cbor_bytes());
        const uplcEvaluatedRedeemers = this.cw3.UPLC.eval_phase_two_raw(
          newTx.to_cbor_bytes(),
          inputs,
          outputs,
          costModels.to_cbor_bytes(),
          this.protocolParams.maxTxExSteps,
          this.protocolParams.maxTxExMem,
          BigInt(slotConfig.zeroTime),
          BigInt(slotConfig.zeroSlot),
          slotConfig.slotDuration
        );
        for (const evaluatedRedeemer of uplcEvaluatedRedeemers) {
          const redeemer = this.cw3.CML.LegacyRedeemer.from_cbor_bytes(evaluatedRedeemer);
          const exUnits = this.cw3.CML.ExUnits.new(redeemer.ex_units().mem(), redeemer.ex_units().steps());
          this.__txBuilder.set_exunits(this.cw3.CML.RedeemerWitnessKey.new(redeemer.tag(), redeemer.index()), exUnits);
        }
      } else {
        throw new Error("Remote TX evaluation is not supported yet");
      }
    }
    this.__txBuilder.add_change_if_needed(this.cw3.CML.Address.from_bech32(this.changeAddress), true);
    return this;
  };
  /**
   * Apply all methods, build TX and return TxFinalizer instance
   * @returns TxFinalizer instance
   */
  applyAndBuild = async () => {
    await this.apply();
    return new TxFinalizer(
      this.cw3,
      this.__txBuilder.build(this.cw3.CML.ChangeSelectionAlgo.Default, this.cw3.CML.Address.from_bech32(this.changeAddress)).build_unchecked().to_cbor_hex()
    );
  };
};

// src/utils/index.ts
import { Buffer as Buffer4 } from "buffer";
import * as Bech32 from "bech32";
import Blake2b2 from "blake2b";

// src/utils/bip39/index.ts
var bip39_exports = {};
__export(bip39_exports, {
  generateMnemonic: () => generateMnemonic,
  mnemonicToEntropy: () => mnemonicToEntropy,
  validateMnemonic: () => validateMnemonic
});
import { sha256 } from "js-sha256";
import { Buffer as Buffer2 } from "buffer";
var INVALID_MNEMONIC = "Invalid mnemonic";
var INVALID_ENTROPY = "Invalid entropy";
var INVALID_CHECKSUM = "Invalid mnemonic checksum";
var WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function toHex(bytes) {
  return Buffer2.from(bytes).toString("hex");
}
function mnemonicToEntropy(mnemonic, wordlist) {
  wordlist = wordlist || DEFAULT_WORDLIST;
  if (!wordlist) {
    throw new Error(WORDLIST_REQUIRED);
  }
  const words = normalize(mnemonic).split(" ");
  if (words.length % 3 !== 0) {
    throw new Error(INVALID_MNEMONIC);
  }
  const bits = words.map((word) => {
    const index = wordlist.indexOf(word);
    if (index === -1) {
      throw new Error(INVALID_MNEMONIC);
    }
    return lpad(index.toString(2), "0", 11);
  }).join("");
  const dividerIndex = Math.floor(bits.length / 33) * 32;
  const entropyBits = bits.slice(0, dividerIndex);
  const checksumBits = bits.slice(dividerIndex);
  const entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte);
  if (entropyBytes.length < 16) {
    throw new Error(INVALID_ENTROPY);
  }
  if (entropyBytes.length > 32) {
    throw new Error(INVALID_ENTROPY);
  }
  if (entropyBytes.length % 4 !== 0) {
    throw new Error(INVALID_ENTROPY);
  }
  const entropy = new Uint8Array(entropyBytes);
  const newChecksum = deriveChecksumBits(entropy);
  if (newChecksum !== checksumBits) {
    throw new Error(INVALID_CHECKSUM);
  }
  return toHex(entropy);
}
function randomValues(array) {
  for (let i = 0, l = array.length; i < l; i++) {
    array[i] = Math.floor(Math.random() * 256);
  }
  return array;
}
function randomBytes(size) {
  const MAX_UINT32 = 4294967295;
  const MAX_BYTES = 65536;
  const bytes = new Uint8Array(size);
  if (size > MAX_UINT32) {
    throw new RangeError("requested too many random bytes");
  }
  if (size > 0) {
    if (size > MAX_BYTES) {
      for (let generated = 0; generated < size; generated += MAX_BYTES) {
        randomValues(bytes.slice(generated, generated + MAX_BYTES));
      }
    } else {
      randomValues(bytes);
    }
  }
  return bytes;
}
function generateMnemonic(strength, rng, wordlist) {
  strength = strength || 128;
  if (strength % 32 !== 0) {
    throw new TypeError(INVALID_ENTROPY);
  }
  rng = rng || randomBytes;
  return entropyToMnemonic(rng(strength / 8), wordlist);
}
function validateMnemonic(mnemonic, wordlist) {
  try {
    mnemonicToEntropy(mnemonic, wordlist);
  } catch (e) {
    return false;
  }
  return true;
}
function entropyToMnemonic(entropy, wordlist) {
  wordlist = wordlist || DEFAULT_WORDLIST;
  if (!wordlist) {
    throw new Error(WORDLIST_REQUIRED);
  }
  if (entropy.length < 16) {
    throw new TypeError(INVALID_ENTROPY);
  }
  if (entropy.length > 32) {
    throw new TypeError(INVALID_ENTROPY);
  }
  if (entropy.length % 4 !== 0) {
    throw new TypeError(INVALID_ENTROPY);
  }
  const entropyBits = bytesToBinary(Array.from(entropy));
  const checksumBits = deriveChecksumBits(entropy);
  const bits = entropyBits + checksumBits;
  const chunks = bits.match(/(.{1,11})/g);
  const words = chunks.map((binary) => {
    const index = binaryToByte(binary);
    return wordlist[index];
  });
  return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" ? words.join("\u3000") : words.join(" ");
}
function deriveChecksumBits(entropyBuffer) {
  const ENT = entropyBuffer.length * 8;
  const CS = ENT / 32;
  const hash2 = sha256.create().update(entropyBuffer).digest();
  return bytesToBinary(Array.from(hash2)).slice(0, CS);
}
function lpad(str, padString, length) {
  while (str.length < length) {
    str = padString + str;
  }
  return str;
}
function bytesToBinary(bytes) {
  return bytes.map((x) => lpad(x.toString(2), "0", 8)).join("");
}
function normalize(str) {
  return (str || "").normalize("NFKD");
}
function binaryToByte(bin) {
  return parseInt(bin, 2);
}
var DEFAULT_WORDLIST = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];

// src/utils/cip4/index.ts
import { Buffer as Buffer3 } from "buffer";
import Blake2b from "blake2b";
var LETTERS = `ABCDEJHKLNOPSTXZ`;
function hash(len, input, message) {
  return Blake2b(len, void 0, void 0, new Uint8Array(Buffer3.from(message))).update(new Uint8Array(Buffer3.from(input))).digest("hex");
}
function textPartFromWalletChecksumImagePart(walletChecksum2) {
  return textPartFromBytes(toBytesInt32(fast1a32(walletChecksum2)));
}
function toBytesInt32(int32) {
  const byteArray = [0, 0, 0, 0];
  for (let index = 0; index < byteArray.length; index++) {
    const byte = int32 & 255;
    byteArray[index] = byte;
    int32 = (int32 - byte) / 256;
  }
  return byteArray;
}
function fast1a32(str) {
  var i, l = str.length - 3, t0 = 0, v0 = 40389, t1 = 0, v1 = 33052;
  for (i = 0; i < l; ) {
    v0 ^= str.charCodeAt(i++);
    t0 = v0 * 403;
    t1 = v1 * 403;
    t1 += v0 << 8;
    v1 = t1 + (t0 >>> 16) & 65535;
    v0 = t0 & 65535;
    v0 ^= str.charCodeAt(i++);
    t0 = v0 * 403;
    t1 = v1 * 403;
    t1 += v0 << 8;
    v1 = t1 + (t0 >>> 16) & 65535;
    v0 = t0 & 65535;
    v0 ^= str.charCodeAt(i++);
    t0 = v0 * 403;
    t1 = v1 * 403;
    t1 += v0 << 8;
    v1 = t1 + (t0 >>> 16) & 65535;
    v0 = t0 & 65535;
    v0 ^= str.charCodeAt(i++);
    t0 = v0 * 403;
    t1 = v1 * 403;
    t1 += v0 << 8;
    v1 = t1 + (t0 >>> 16) & 65535;
    v0 = t0 & 65535;
  }
  while (i < l + 3) {
    v0 ^= str.charCodeAt(i++);
    t0 = v0 * 403;
    t1 = v1 * 403;
    t1 += v0 << 8;
    v1 = t1 + (t0 >>> 16) & 65535;
    v0 = t0 & 65535;
  }
  return (v1 << 16 >>> 0) + v0;
}
function textPartFromBytes([a, b, c, d]) {
  const letters = (x) => `${LETTERS[Math.floor(x / 16)]}${LETTERS[x % 16]}`;
  const numbers = `${((c << 8) + d) % 1e4}`.padStart(4, "0");
  return `${letters(a)}${letters(b)}-${numbers}`;
}
function walletChecksum(publicKeyHash) {
  const checksumImage = hash(64, publicKeyHash, "wallets checksum");
  const checksumId = textPartFromWalletChecksumImagePart(checksumImage);
  return { checksumId, checksumImage };
}

// src/utils/cborg/cborg.js
var cborg_exports = {};
__export(cborg_exports, {
  Token: () => Token,
  Tokenizer: () => Tokeniser,
  Type: () => Type,
  decode: () => decode,
  decodeFirst: () => decodeFirst,
  encode: () => encode,
  tokensToObject: () => tokensToObject
});

// src/utils/cborg/lib/is.js
var typeofs = [
  "string",
  "number",
  "bigint",
  "symbol"
];
var objectTypeNames = [
  "Function",
  "Generator",
  "AsyncGenerator",
  "GeneratorFunction",
  "AsyncGeneratorFunction",
  "AsyncFunction",
  "Observable",
  "Array",
  "Buffer",
  "Object",
  "RegExp",
  "Date",
  "Error",
  "Map",
  "Set",
  "WeakMap",
  "WeakSet",
  "ArrayBuffer",
  "SharedArrayBuffer",
  "DataView",
  "Promise",
  "URL",
  "HTMLElement",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Uint16Array",
  "Int32Array",
  "Uint32Array",
  "Float32Array",
  "Float64Array",
  "BigInt64Array",
  "BigUint64Array"
];
function is(value) {
  if (value === null) {
    return "null";
  }
  if (value === void 0) {
    return "undefined";
  }
  if (value === true || value === false) {
    return "boolean";
  }
  const typeOf = typeof value;
  if (typeofs.includes(typeOf)) {
    return typeOf;
  }
  if (typeOf === "function") {
    return "Function";
  }
  if (Array.isArray(value)) {
    return "Array";
  }
  if (isBuffer(value)) {
    return "Buffer";
  }
  const objectType = getObjectType(value);
  if (objectType) {
    return objectType;
  }
  return "Object";
}
function isBuffer(value) {
  return value && value.constructor && value.constructor.isBuffer && value.constructor.isBuffer.call(null, value);
}
function getObjectType(value) {
  const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
  if (objectTypeNames.includes(objectTypeName)) {
    return objectTypeName;
  }
  return void 0;
}

// src/utils/cborg/lib/token.js
var Type = class {
  /**
   * @param {number} major
   * @param {string} name
   * @param {boolean} terminal
   */
  constructor(major, name, terminal) {
    this.major = major;
    this.majorEncoded = major << 5;
    this.name = name;
    this.terminal = terminal;
  }
  /* c8 ignore next 3 */
  toString() {
    return `Type[${this.major}].${this.name}`;
  }
  /**
   * @param {Type} typ
   * @returns {number}
   */
  compare(typ) {
    return this.major < typ.major ? -1 : this.major > typ.major ? 1 : 0;
  }
};
Type.uint = new Type(0, "uint", true);
Type.negint = new Type(1, "negint", true);
Type.bytes = new Type(2, "bytes", true);
Type.string = new Type(3, "string", true);
Type.array = new Type(4, "array", false);
Type.map = new Type(5, "map", false);
Type.tag = new Type(6, "tag", false);
Type.float = new Type(7, "float", true);
Type.false = new Type(7, "false", true);
Type.true = new Type(7, "true", true);
Type.null = new Type(7, "null", true);
Type.undefined = new Type(7, "undefined", true);
Type.break = new Type(7, "break", true);
var Token = class {
  /**
   * @param {Type} type
   * @param {any} [value]
   * @param {number} [encodedLength]
   */
  constructor(type, value, encodedLength) {
    this.type = type;
    this.value = value;
    this.encodedLength = encodedLength;
    this.encodedBytes = void 0;
    this.byteValue = void 0;
  }
  /* c8 ignore next 3 */
  toString() {
    return `Token[${this.type}].${this.value}`;
  }
};

// src/utils/cborg/lib/byte-utils.js
var useBuffer = globalThis.process && // @ts-ignore
!globalThis.process.browser && // @ts-ignore
globalThis.Buffer && // @ts-ignore
typeof globalThis.Buffer.isBuffer === "function";
var textDecoder = new TextDecoder();
var textEncoder = new TextEncoder();
function isBuffer2(buf2) {
  return useBuffer && globalThis.Buffer.isBuffer(buf2);
}
function asU8A(buf2) {
  if (!(buf2 instanceof Uint8Array)) {
    return Uint8Array.from(buf2);
  }
  return isBuffer2(buf2) ? new Uint8Array(buf2.buffer, buf2.byteOffset, buf2.byteLength) : buf2;
}
var toString = useBuffer ? (
  // eslint-disable-line operator-linebreak
  /**
   * @param {Uint8Array} bytes
   * @param {number} start
   * @param {number} end
   */
  (bytes, start, end) => {
    return end - start > 64 ? (
      // eslint-disable-line operator-linebreak
      // @ts-ignore
      globalThis.Buffer.from(bytes.subarray(start, end)).toString("utf8")
    ) : utf8Slice(bytes, start, end);
  }
) : (
  // eslint-disable-line operator-linebreak
  /**
   * @param {Uint8Array} bytes
   * @param {number} start
   * @param {number} end
   */
  (bytes, start, end) => {
    return end - start > 64 ? textDecoder.decode(bytes.subarray(start, end)) : utf8Slice(bytes, start, end);
  }
);
var fromString = useBuffer ? (
  // eslint-disable-line operator-linebreak
  /**
   * @param {string} string
   */
  (string) => {
    return string.length > 64 ? (
      // eslint-disable-line operator-linebreak
      // @ts-ignore
      globalThis.Buffer.from(string)
    ) : utf8ToBytes(string);
  }
) : (
  // eslint-disable-line operator-linebreak
  /**
   * @param {string} string
   */
  (string) => {
    return string.length > 64 ? textEncoder.encode(string) : utf8ToBytes(string);
  }
);
var fromArray = (arr) => {
  return Uint8Array.from(arr);
};
var slice = useBuffer ? (
  // eslint-disable-line operator-linebreak
  /**
   * @param {Uint8Array} bytes
   * @param {number} start
   * @param {number} end
   */
  (bytes, start, end) => {
    if (isBuffer2(bytes)) {
      return new Uint8Array(bytes.subarray(start, end));
    }
    return bytes.slice(start, end);
  }
) : (
  // eslint-disable-line operator-linebreak
  /**
   * @param {Uint8Array} bytes
   * @param {number} start
   * @param {number} end
   */
  (bytes, start, end) => {
    return bytes.slice(start, end);
  }
);
var concat = useBuffer ? (
  // eslint-disable-line operator-linebreak
  /**
   * @param {Uint8Array[]} chunks
   * @param {number} length
   * @returns {Uint8Array}
   */
  (chunks, length) => {
    chunks = chunks.map((c) => c instanceof Uint8Array ? c : (
      // eslint-disable-line operator-linebreak
      // @ts-ignore
      globalThis.Buffer.from(c)
    ));
    return asU8A(globalThis.Buffer.concat(chunks, length));
  }
) : (
  // eslint-disable-line operator-linebreak
  /**
   * @param {Uint8Array[]} chunks
   * @param {number} length
   * @returns {Uint8Array}
   */
  (chunks, length) => {
    const out = new Uint8Array(length);
    let off = 0;
    for (let b of chunks) {
      if (off + b.length > out.length) {
        b = b.subarray(0, out.length - off);
      }
      out.set(b, off);
      off += b.length;
    }
    return out;
  }
);
var alloc = useBuffer ? (
  // eslint-disable-line operator-linebreak
  /**
   * @param {number} size
   * @returns {Uint8Array}
   */
  (size) => {
    return globalThis.Buffer.allocUnsafe(size);
  }
) : (
  // eslint-disable-line operator-linebreak
  /**
   * @param {number} size
   * @returns {Uint8Array}
   */
  (size) => {
    return new Uint8Array(size);
  }
);
function compare(b1, b2) {
  if (isBuffer2(b1) && isBuffer2(b2)) {
    return b1.compare(b2);
  }
  for (let i = 0; i < b1.length; i++) {
    if (b1[i] === b2[i]) {
      continue;
    }
    return b1[i] < b2[i] ? -1 : 1;
  }
  return 0;
}
function utf8ToBytes(str) {
  const out = [];
  let p = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if (c < 128) {
      out[p++] = c;
    } else if (c < 2048) {
      out[p++] = c >> 6 | 192;
      out[p++] = c & 63 | 128;
    } else if ((c & 64512) === 55296 && i + 1 < str.length && (str.charCodeAt(i + 1) & 64512) === 56320) {
      c = 65536 + ((c & 1023) << 10) + (str.charCodeAt(++i) & 1023);
      out[p++] = c >> 18 | 240;
      out[p++] = c >> 12 & 63 | 128;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    } else {
      out[p++] = c >> 12 | 224;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    }
  }
  return out;
}
function utf8Slice(buf2, offset, end) {
  const res = [];
  while (offset < end) {
    const firstByte = buf2[offset];
    let codePoint = null;
    let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
    if (offset + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 128) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf2[offset + 1];
          if ((secondByte & 192) === 128) {
            tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
            if (tempCodePoint > 127) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf2[offset + 1];
          thirdByte = buf2[offset + 2];
          if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
            tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
            if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf2[offset + 1];
          thirdByte = buf2[offset + 2];
          fourthByte = buf2[offset + 3];
          if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
            tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
            if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      codePoint = 65533;
      bytesPerSequence = 1;
    } else if (codePoint > 65535) {
      codePoint -= 65536;
      res.push(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    res.push(codePoint);
    offset += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(codePoints) {
  const len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints);
  }
  let res = "";
  let i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    );
  }
  return res;
}

// src/utils/cborg/lib/bl.js
var defaultChunkSize = 256;
var Bl = class {
  /**
   * @param {number} [chunkSize]
   */
  constructor(chunkSize = defaultChunkSize) {
    this.chunkSize = chunkSize;
    this.cursor = 0;
    this.maxCursor = -1;
    this.chunks = [];
    this._initReuseChunk = null;
  }
  reset() {
    this.cursor = 0;
    this.maxCursor = -1;
    if (this.chunks.length) {
      this.chunks = [];
    }
    if (this._initReuseChunk !== null) {
      this.chunks.push(this._initReuseChunk);
      this.maxCursor = this._initReuseChunk.length - 1;
    }
  }
  /**
   * @param {Uint8Array|number[]} bytes
   */
  push(bytes) {
    let topChunk = this.chunks[this.chunks.length - 1];
    const newMax = this.cursor + bytes.length;
    if (newMax <= this.maxCursor + 1) {
      const chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
      topChunk.set(bytes, chunkPos);
    } else {
      if (topChunk) {
        const chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
        if (chunkPos < topChunk.length) {
          this.chunks[this.chunks.length - 1] = topChunk.subarray(0, chunkPos);
          this.maxCursor = this.cursor - 1;
        }
      }
      if (bytes.length < 64 && bytes.length < this.chunkSize) {
        topChunk = alloc(this.chunkSize);
        this.chunks.push(topChunk);
        this.maxCursor += topChunk.length;
        if (this._initReuseChunk === null) {
          this._initReuseChunk = topChunk;
        }
        topChunk.set(bytes, 0);
      } else {
        this.chunks.push(bytes);
        this.maxCursor += bytes.length;
      }
    }
    this.cursor += bytes.length;
  }
  /**
   * @param {boolean} [reset]
   * @returns {Uint8Array}
   */
  toBytes(reset = false) {
    let byts;
    if (this.chunks.length === 1) {
      const chunk = this.chunks[0];
      if (reset && this.cursor > chunk.length / 2) {
        byts = this.cursor === chunk.length ? chunk : chunk.subarray(0, this.cursor);
        this._initReuseChunk = null;
        this.chunks = [];
      } else {
        byts = slice(chunk, 0, this.cursor);
      }
    } else {
      byts = concat(this.chunks, this.cursor);
    }
    if (reset) {
      this.reset();
    }
    return byts;
  }
};

// src/utils/cborg/lib/common.js
var decodeErrPrefix = "CBOR decode error:";
var encodeErrPrefix = "CBOR encode error:";
var uintMinorPrefixBytes = [];
uintMinorPrefixBytes[23] = 1;
uintMinorPrefixBytes[24] = 2;
uintMinorPrefixBytes[25] = 3;
uintMinorPrefixBytes[26] = 5;
uintMinorPrefixBytes[27] = 9;
function assertEnoughData(data, pos, need) {
  if (data.length - pos < need) {
    throw new Error(`${decodeErrPrefix} not enough data for type`);
  }
}

// src/utils/cborg/lib/0uint.js
var uintBoundaries = [24, 256, 65536, 4294967296, BigInt("18446744073709551616")];
function readUint8(data, offset, options) {
  assertEnoughData(data, offset, 1);
  const value = data[offset];
  if (options.strict === true && value < uintBoundaries[0]) {
    throw new Error(`${decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
  }
  return value;
}
function readUint16(data, offset, options) {
  assertEnoughData(data, offset, 2);
  const value = data[offset] << 8 | data[offset + 1];
  if (options.strict === true && value < uintBoundaries[1]) {
    throw new Error(`${decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
  }
  return value;
}
function readUint32(data, offset, options) {
  assertEnoughData(data, offset, 4);
  const value = data[offset] * 16777216 + (data[offset + 1] << 16) + (data[offset + 2] << 8) + data[offset + 3];
  if (options.strict === true && value < uintBoundaries[2]) {
    throw new Error(`${decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
  }
  return value;
}
function readUint64(data, offset, options) {
  assertEnoughData(data, offset, 8);
  const hi = data[offset] * 16777216 + (data[offset + 1] << 16) + (data[offset + 2] << 8) + data[offset + 3];
  const lo = data[offset + 4] * 16777216 + (data[offset + 5] << 16) + (data[offset + 6] << 8) + data[offset + 7];
  const value = (BigInt(hi) << BigInt(32)) + BigInt(lo);
  if (options.strict === true && value < uintBoundaries[3]) {
    throw new Error(`${decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
  }
  if (value <= Number.MAX_SAFE_INTEGER) {
    return Number(value);
  }
  if (options.allowBigInt === true) {
    return value;
  }
  throw new Error(`${decodeErrPrefix} integers outside of the safe integer range are not supported`);
}
function decodeUint8(data, pos, _minor, options) {
  return new Token(Type.uint, readUint8(data, pos + 1, options), 2);
}
function decodeUint16(data, pos, _minor, options) {
  return new Token(Type.uint, readUint16(data, pos + 1, options), 3);
}
function decodeUint32(data, pos, _minor, options) {
  return new Token(Type.uint, readUint32(data, pos + 1, options), 5);
}
function decodeUint64(data, pos, _minor, options) {
  return new Token(Type.uint, readUint64(data, pos + 1, options), 9);
}
function encodeUint(buf2, token) {
  return encodeUintValue(buf2, 0, token.value);
}
function encodeUintValue(buf2, major, uint) {
  if (uint < uintBoundaries[0]) {
    const nuint = Number(uint);
    buf2.push([major | nuint]);
  } else if (uint < uintBoundaries[1]) {
    const nuint = Number(uint);
    buf2.push([major | 24, nuint]);
  } else if (uint < uintBoundaries[2]) {
    const nuint = Number(uint);
    buf2.push([major | 25, nuint >>> 8, nuint & 255]);
  } else if (uint < uintBoundaries[3]) {
    const nuint = Number(uint);
    buf2.push([major | 26, nuint >>> 24 & 255, nuint >>> 16 & 255, nuint >>> 8 & 255, nuint & 255]);
  } else {
    const buint = BigInt(uint);
    if (buint < uintBoundaries[4]) {
      const set = [major | 27, 0, 0, 0, 0, 0, 0, 0];
      let lo = Number(buint & BigInt(4294967295));
      let hi = Number(buint >> BigInt(32) & BigInt(4294967295));
      set[8] = lo & 255;
      lo = lo >> 8;
      set[7] = lo & 255;
      lo = lo >> 8;
      set[6] = lo & 255;
      lo = lo >> 8;
      set[5] = lo & 255;
      set[4] = hi & 255;
      hi = hi >> 8;
      set[3] = hi & 255;
      hi = hi >> 8;
      set[2] = hi & 255;
      hi = hi >> 8;
      set[1] = hi & 255;
      buf2.push(set);
    } else {
      throw new Error(`${decodeErrPrefix} encountered BigInt larger than allowable range`);
    }
  }
}
encodeUint.encodedSize = function encodedSize(token) {
  return encodeUintValue.encodedSize(token.value);
};
encodeUintValue.encodedSize = function encodedSize2(uint) {
  if (uint < uintBoundaries[0]) {
    return 1;
  }
  if (uint < uintBoundaries[1]) {
    return 2;
  }
  if (uint < uintBoundaries[2]) {
    return 3;
  }
  if (uint < uintBoundaries[3]) {
    return 5;
  }
  return 9;
};
encodeUint.compareTokens = function compareTokens(tok1, tok2) {
  return tok1.value < tok2.value ? -1 : tok1.value > tok2.value ? 1 : (
    /* c8 ignore next */
    0
  );
};

// src/utils/cborg/lib/1negint.js
function decodeNegint8(data, pos, _minor, options) {
  return new Token(Type.negint, -1 - readUint8(data, pos + 1, options), 2);
}
function decodeNegint16(data, pos, _minor, options) {
  return new Token(Type.negint, -1 - readUint16(data, pos + 1, options), 3);
}
function decodeNegint32(data, pos, _minor, options) {
  return new Token(Type.negint, -1 - readUint32(data, pos + 1, options), 5);
}
var neg1b = BigInt(-1);
var pos1b = BigInt(1);
function decodeNegint64(data, pos, _minor, options) {
  const int = readUint64(data, pos + 1, options);
  if (typeof int !== "bigint") {
    const value = -1 - int;
    if (value >= Number.MIN_SAFE_INTEGER) {
      return new Token(Type.negint, value, 9);
    }
  }
  if (options.allowBigInt !== true) {
    throw new Error(`${decodeErrPrefix} integers outside of the safe integer range are not supported`);
  }
  return new Token(Type.negint, neg1b - BigInt(int), 9);
}
function encodeNegint(buf2, token) {
  const negint = token.value;
  const unsigned = typeof negint === "bigint" ? negint * neg1b - pos1b : negint * -1 - 1;
  encodeUintValue(buf2, token.type.majorEncoded, unsigned);
}
encodeNegint.encodedSize = function encodedSize3(token) {
  const negint = token.value;
  const unsigned = typeof negint === "bigint" ? negint * neg1b - pos1b : negint * -1 - 1;
  if (unsigned < uintBoundaries[0]) {
    return 1;
  }
  if (unsigned < uintBoundaries[1]) {
    return 2;
  }
  if (unsigned < uintBoundaries[2]) {
    return 3;
  }
  if (unsigned < uintBoundaries[3]) {
    return 5;
  }
  return 9;
};
encodeNegint.compareTokens = function compareTokens2(tok1, tok2) {
  return tok1.value < tok2.value ? 1 : tok1.value > tok2.value ? -1 : (
    /* c8 ignore next */
    0
  );
};

// src/utils/cborg/lib/2bytes.js
function toToken(data, pos, prefix, length) {
  assertEnoughData(data, pos, prefix + length);
  const buf2 = slice(data, pos + prefix, pos + prefix + length);
  return new Token(Type.bytes, buf2, prefix + length);
}
function decodeBytesCompact(data, pos, minor, _options) {
  return toToken(data, pos, 1, minor);
}
function decodeBytes8(data, pos, _minor, options) {
  return toToken(data, pos, 2, readUint8(data, pos + 1, options));
}
function decodeBytes16(data, pos, _minor, options) {
  return toToken(data, pos, 3, readUint16(data, pos + 1, options));
}
function decodeBytes32(data, pos, _minor, options) {
  return toToken(data, pos, 5, readUint32(data, pos + 1, options));
}
function decodeBytes64(data, pos, _minor, options) {
  const l = readUint64(data, pos + 1, options);
  if (typeof l === "bigint") {
    throw new Error(`${decodeErrPrefix} 64-bit integer bytes lengths not supported`);
  }
  return toToken(data, pos, 9, l);
}
function tokenBytes(token) {
  if (token.encodedBytes === void 0) {
    token.encodedBytes = token.type === Type.string ? fromString(token.value) : token.value;
  }
  return token.encodedBytes;
}
function encodeBytes(buf2, token) {
  const bytes = tokenBytes(token);
  encodeUintValue(buf2, token.type.majorEncoded, bytes.length);
  buf2.push(bytes);
}
encodeBytes.encodedSize = function encodedSize4(token) {
  const bytes = tokenBytes(token);
  return encodeUintValue.encodedSize(bytes.length) + bytes.length;
};
encodeBytes.compareTokens = function compareTokens3(tok1, tok2) {
  return compareBytes(tokenBytes(tok1), tokenBytes(tok2));
};
function compareBytes(b1, b2) {
  return b1.length < b2.length ? -1 : b1.length > b2.length ? 1 : compare(b1, b2);
}

// src/utils/cborg/lib/3string.js
function toToken2(data, pos, prefix, length, options) {
  const totLength = prefix + length;
  assertEnoughData(data, pos, totLength);
  const tok = new Token(Type.string, toString(data, pos + prefix, pos + totLength), totLength);
  if (options.retainStringBytes === true) {
    tok.byteValue = slice(data, pos + prefix, pos + totLength);
  }
  return tok;
}
function decodeStringCompact(data, pos, minor, options) {
  return toToken2(data, pos, 1, minor, options);
}
function decodeString8(data, pos, _minor, options) {
  return toToken2(data, pos, 2, readUint8(data, pos + 1, options), options);
}
function decodeString16(data, pos, _minor, options) {
  return toToken2(data, pos, 3, readUint16(data, pos + 1, options), options);
}
function decodeString32(data, pos, _minor, options) {
  return toToken2(data, pos, 5, readUint32(data, pos + 1, options), options);
}
function decodeString64(data, pos, _minor, options) {
  const l = readUint64(data, pos + 1, options);
  if (typeof l === "bigint") {
    throw new Error(`${decodeErrPrefix} 64-bit integer string lengths not supported`);
  }
  return toToken2(data, pos, 9, l, options);
}
var encodeString = encodeBytes;

// src/utils/cborg/lib/4array.js
function toToken3(_data, _pos, prefix, length) {
  return new Token(Type.array, length, prefix);
}
function decodeArrayCompact(data, pos, minor, _options) {
  return toToken3(data, pos, 1, minor);
}
function decodeArray8(data, pos, _minor, options) {
  return toToken3(data, pos, 2, readUint8(data, pos + 1, options));
}
function decodeArray16(data, pos, _minor, options) {
  return toToken3(data, pos, 3, readUint16(data, pos + 1, options));
}
function decodeArray32(data, pos, _minor, options) {
  return toToken3(data, pos, 5, readUint32(data, pos + 1, options));
}
function decodeArray64(data, pos, _minor, options) {
  const l = readUint64(data, pos + 1, options);
  if (typeof l === "bigint") {
    throw new Error(`${decodeErrPrefix} 64-bit integer array lengths not supported`);
  }
  return toToken3(data, pos, 9, l);
}
function decodeArrayIndefinite(data, pos, _minor, options) {
  if (options.allowIndefinite === false) {
    throw new Error(`${decodeErrPrefix} indefinite length items not allowed`);
  }
  return toToken3(data, pos, 1, Infinity);
}
function encodeArray(buf2, token) {
  encodeUintValue(buf2, Type.array.majorEncoded, token.value);
}
encodeArray.compareTokens = encodeUint.compareTokens;
encodeArray.encodedSize = function encodedSize5(token) {
  return encodeUintValue.encodedSize(token.value);
};

// src/utils/cborg/lib/5map.js
function toToken4(_data, _pos, prefix, length) {
  return new Token(Type.map, length, prefix);
}
function decodeMapCompact(data, pos, minor, _options) {
  return toToken4(data, pos, 1, minor);
}
function decodeMap8(data, pos, _minor, options) {
  return toToken4(data, pos, 2, readUint8(data, pos + 1, options));
}
function decodeMap16(data, pos, _minor, options) {
  return toToken4(data, pos, 3, readUint16(data, pos + 1, options));
}
function decodeMap32(data, pos, _minor, options) {
  return toToken4(data, pos, 5, readUint32(data, pos + 1, options));
}
function decodeMap64(data, pos, _minor, options) {
  const l = readUint64(data, pos + 1, options);
  if (typeof l === "bigint") {
    throw new Error(`${decodeErrPrefix} 64-bit integer map lengths not supported`);
  }
  return toToken4(data, pos, 9, l);
}
function decodeMapIndefinite(data, pos, _minor, options) {
  if (options.allowIndefinite === false) {
    throw new Error(`${decodeErrPrefix} indefinite length items not allowed`);
  }
  return toToken4(data, pos, 1, Infinity);
}
function encodeMap(buf2, token) {
  encodeUintValue(buf2, Type.map.majorEncoded, token.value);
}
encodeMap.compareTokens = encodeUint.compareTokens;
encodeMap.encodedSize = function encodedSize6(token) {
  return encodeUintValue.encodedSize(token.value);
};

// src/utils/cborg/lib/6tag.js
function decodeTagCompact(_data, _pos, minor, _options) {
  return new Token(Type.tag, minor, 1);
}
function decodeTag8(data, pos, _minor, options) {
  return new Token(Type.tag, readUint8(data, pos + 1, options), 2);
}
function decodeTag16(data, pos, _minor, options) {
  return new Token(Type.tag, readUint16(data, pos + 1, options), 3);
}
function decodeTag32(data, pos, _minor, options) {
  return new Token(Type.tag, readUint32(data, pos + 1, options), 5);
}
function decodeTag64(data, pos, _minor, options) {
  return new Token(Type.tag, readUint64(data, pos + 1, options), 9);
}
function encodeTag(buf2, token) {
  encodeUintValue(buf2, Type.tag.majorEncoded, token.value);
}
encodeTag.compareTokens = encodeUint.compareTokens;
encodeTag.encodedSize = function encodedSize7(token) {
  return encodeUintValue.encodedSize(token.value);
};

// src/utils/cborg/lib/7float.js
var MINOR_FALSE = 20;
var MINOR_TRUE = 21;
var MINOR_NULL = 22;
var MINOR_UNDEFINED = 23;
function decodeUndefined(_data, _pos, _minor, options) {
  if (options.allowUndefined === false) {
    throw new Error(`${decodeErrPrefix} undefined values are not supported`);
  } else if (options.coerceUndefinedToNull === true) {
    return new Token(Type.null, null, 1);
  }
  return new Token(Type.undefined, void 0, 1);
}
function decodeBreak(_data, _pos, _minor, options) {
  if (options.allowIndefinite === false) {
    throw new Error(`${decodeErrPrefix} indefinite length items not allowed`);
  }
  return new Token(Type.break, void 0, 1);
}
function createToken(value, bytes, options) {
  if (options) {
    if (options.allowNaN === false && Number.isNaN(value)) {
      throw new Error(`${decodeErrPrefix} NaN values are not supported`);
    }
    if (options.allowInfinity === false && (value === Infinity || value === -Infinity)) {
      throw new Error(`${decodeErrPrefix} Infinity values are not supported`);
    }
  }
  return new Token(Type.float, value, bytes);
}
function decodeFloat16(data, pos, _minor, options) {
  return createToken(readFloat16(data, pos + 1), 3, options);
}
function decodeFloat32(data, pos, _minor, options) {
  return createToken(readFloat32(data, pos + 1), 5, options);
}
function decodeFloat64(data, pos, _minor, options) {
  return createToken(readFloat64(data, pos + 1), 9, options);
}
function encodeFloat(buf2, token, options) {
  const float = token.value;
  if (float === false) {
    buf2.push([Type.float.majorEncoded | MINOR_FALSE]);
  } else if (float === true) {
    buf2.push([Type.float.majorEncoded | MINOR_TRUE]);
  } else if (float === null) {
    buf2.push([Type.float.majorEncoded | MINOR_NULL]);
  } else if (float === void 0) {
    buf2.push([Type.float.majorEncoded | MINOR_UNDEFINED]);
  } else {
    let decoded;
    let success = false;
    if (!options || options.float64 !== true) {
      encodeFloat16(float);
      decoded = readFloat16(ui8a, 1);
      if (float === decoded || Number.isNaN(float)) {
        ui8a[0] = 249;
        buf2.push(ui8a.slice(0, 3));
        success = true;
      } else {
        encodeFloat32(float);
        decoded = readFloat32(ui8a, 1);
        if (float === decoded) {
          ui8a[0] = 250;
          buf2.push(ui8a.slice(0, 5));
          success = true;
        }
      }
    }
    if (!success) {
      encodeFloat64(float);
      decoded = readFloat64(ui8a, 1);
      ui8a[0] = 251;
      buf2.push(ui8a.slice(0, 9));
    }
  }
}
encodeFloat.encodedSize = function encodedSize8(token, options) {
  const float = token.value;
  if (float === false || float === true || float === null || float === void 0) {
    return 1;
  }
  if (!options || options.float64 !== true) {
    encodeFloat16(float);
    let decoded = readFloat16(ui8a, 1);
    if (float === decoded || Number.isNaN(float)) {
      return 3;
    }
    encodeFloat32(float);
    decoded = readFloat32(ui8a, 1);
    if (float === decoded) {
      return 5;
    }
  }
  return 9;
};
var buffer = new ArrayBuffer(9);
var dataView = new DataView(buffer, 1);
var ui8a = new Uint8Array(buffer, 0);
function encodeFloat16(inp) {
  if (inp === Infinity) {
    dataView.setUint16(0, 31744, false);
  } else if (inp === -Infinity) {
    dataView.setUint16(0, 64512, false);
  } else if (Number.isNaN(inp)) {
    dataView.setUint16(0, 32256, false);
  } else {
    dataView.setFloat32(0, inp);
    const valu32 = dataView.getUint32(0);
    const exponent = (valu32 & 2139095040) >> 23;
    const mantissa = valu32 & 8388607;
    if (exponent === 255) {
      dataView.setUint16(0, 31744, false);
    } else if (exponent === 0) {
      dataView.setUint16(0, (inp & 2147483648) >> 16 | mantissa >> 13, false);
    } else {
      const logicalExponent = exponent - 127;
      if (logicalExponent < -24) {
        dataView.setUint16(0, 0);
      } else if (logicalExponent < -14) {
        dataView.setUint16(0, (valu32 & 2147483648) >> 16 | /* sign bit */
        1 << 24 + logicalExponent, false);
      } else {
        dataView.setUint16(0, (valu32 & 2147483648) >> 16 | logicalExponent + 15 << 10 | mantissa >> 13, false);
      }
    }
  }
}
function readFloat16(ui8a2, pos) {
  if (ui8a2.length - pos < 2) {
    throw new Error(`${decodeErrPrefix} not enough data for float16`);
  }
  const half = (ui8a2[pos] << 8) + ui8a2[pos + 1];
  if (half === 31744) {
    return Infinity;
  }
  if (half === 64512) {
    return -Infinity;
  }
  if (half === 32256) {
    return NaN;
  }
  const exp = half >> 10 & 31;
  const mant = half & 1023;
  let val;
  if (exp === 0) {
    val = mant * 2 ** -24;
  } else if (exp !== 31) {
    val = (mant + 1024) * 2 ** (exp - 25);
  } else {
    val = mant === 0 ? Infinity : NaN;
  }
  return half & 32768 ? -val : val;
}
function encodeFloat32(inp) {
  dataView.setFloat32(0, inp, false);
}
function readFloat32(ui8a2, pos) {
  if (ui8a2.length - pos < 4) {
    throw new Error(`${decodeErrPrefix} not enough data for float32`);
  }
  const offset = (ui8a2.byteOffset || 0) + pos;
  return new DataView(ui8a2.buffer, offset, 4).getFloat32(0, false);
}
function encodeFloat64(inp) {
  dataView.setFloat64(0, inp, false);
}
function readFloat64(ui8a2, pos) {
  if (ui8a2.length - pos < 8) {
    throw new Error(`${decodeErrPrefix} not enough data for float64`);
  }
  const offset = (ui8a2.byteOffset || 0) + pos;
  return new DataView(ui8a2.buffer, offset, 8).getFloat64(0, false);
}
encodeFloat.compareTokens = encodeUint.compareTokens;

// src/utils/cborg/lib/jump.js
function invalidMinor(data, pos, minor) {
  throw new Error(`${decodeErrPrefix} encountered invalid minor (${minor}) for major ${data[pos] >>> 5}`);
}
function errorer(msg) {
  return () => {
    throw new Error(`${decodeErrPrefix} ${msg}`);
  };
}
var jump = [];
for (let i = 0; i <= 23; i++) {
  jump[i] = invalidMinor;
}
jump[24] = decodeUint8;
jump[25] = decodeUint16;
jump[26] = decodeUint32;
jump[27] = decodeUint64;
jump[28] = invalidMinor;
jump[29] = invalidMinor;
jump[30] = invalidMinor;
jump[31] = invalidMinor;
for (let i = 32; i <= 55; i++) {
  jump[i] = invalidMinor;
}
jump[56] = decodeNegint8;
jump[57] = decodeNegint16;
jump[58] = decodeNegint32;
jump[59] = decodeNegint64;
jump[60] = invalidMinor;
jump[61] = invalidMinor;
jump[62] = invalidMinor;
jump[63] = invalidMinor;
for (let i = 64; i <= 87; i++) {
  jump[i] = decodeBytesCompact;
}
jump[88] = decodeBytes8;
jump[89] = decodeBytes16;
jump[90] = decodeBytes32;
jump[91] = decodeBytes64;
jump[92] = invalidMinor;
jump[93] = invalidMinor;
jump[94] = invalidMinor;
jump[95] = errorer("indefinite length bytes/strings are not supported");
for (let i = 96; i <= 119; i++) {
  jump[i] = decodeStringCompact;
}
jump[120] = decodeString8;
jump[121] = decodeString16;
jump[122] = decodeString32;
jump[123] = decodeString64;
jump[124] = invalidMinor;
jump[125] = invalidMinor;
jump[126] = invalidMinor;
jump[127] = errorer("indefinite length bytes/strings are not supported");
for (let i = 128; i <= 151; i++) {
  jump[i] = decodeArrayCompact;
}
jump[152] = decodeArray8;
jump[153] = decodeArray16;
jump[154] = decodeArray32;
jump[155] = decodeArray64;
jump[156] = invalidMinor;
jump[157] = invalidMinor;
jump[158] = invalidMinor;
jump[159] = decodeArrayIndefinite;
for (let i = 160; i <= 183; i++) {
  jump[i] = decodeMapCompact;
}
jump[184] = decodeMap8;
jump[185] = decodeMap16;
jump[186] = decodeMap32;
jump[187] = decodeMap64;
jump[188] = invalidMinor;
jump[189] = invalidMinor;
jump[190] = invalidMinor;
jump[191] = decodeMapIndefinite;
for (let i = 192; i <= 215; i++) {
  jump[i] = decodeTagCompact;
}
jump[216] = decodeTag8;
jump[217] = decodeTag16;
jump[218] = decodeTag32;
jump[219] = decodeTag64;
jump[220] = invalidMinor;
jump[221] = invalidMinor;
jump[222] = invalidMinor;
jump[223] = invalidMinor;
for (let i = 224; i <= 243; i++) {
  jump[i] = errorer("simple values are not supported");
}
jump[244] = invalidMinor;
jump[245] = invalidMinor;
jump[246] = invalidMinor;
jump[247] = decodeUndefined;
jump[248] = errorer("simple values are not supported");
jump[249] = decodeFloat16;
jump[250] = decodeFloat32;
jump[251] = decodeFloat64;
jump[252] = invalidMinor;
jump[253] = invalidMinor;
jump[254] = invalidMinor;
jump[255] = decodeBreak;
var quick = [];
for (let i = 0; i < 24; i++) {
  quick[i] = new Token(Type.uint, i, 1);
}
for (let i = -1; i >= -24; i--) {
  quick[31 - i] = new Token(Type.negint, i, 1);
}
quick[64] = new Token(Type.bytes, new Uint8Array(0), 1);
quick[96] = new Token(Type.string, "", 1);
quick[128] = new Token(Type.array, 0, 1);
quick[160] = new Token(Type.map, 0, 1);
quick[244] = new Token(Type.false, false, 1);
quick[245] = new Token(Type.true, true, 1);
quick[246] = new Token(Type.null, null, 1);
function quickEncodeToken(token) {
  switch (token.type) {
    case Type.false:
      return fromArray([244]);
    case Type.true:
      return fromArray([245]);
    case Type.null:
      return fromArray([246]);
    case Type.bytes:
      if (!token.value.length) {
        return fromArray([64]);
      }
      return;
    case Type.string:
      if (token.value === "") {
        return fromArray([96]);
      }
      return;
    case Type.array:
      if (token.value === 0) {
        return fromArray([128]);
      }
      return;
    case Type.map:
      if (token.value === 0) {
        return fromArray([160]);
      }
      return;
    case Type.uint:
      if (token.value < 24) {
        return fromArray([Number(token.value)]);
      }
      return;
    case Type.negint:
      if (token.value >= -24) {
        return fromArray([31 - Number(token.value)]);
      }
  }
}

// src/utils/cborg/lib/encode.js
var defaultEncodeOptions = {
  float64: false,
  mapSorter,
  quickEncodeToken
};
function makeCborEncoders() {
  const encoders = [];
  encoders[Type.uint.major] = encodeUint;
  encoders[Type.negint.major] = encodeNegint;
  encoders[Type.bytes.major] = encodeBytes;
  encoders[Type.string.major] = encodeString;
  encoders[Type.array.major] = encodeArray;
  encoders[Type.map.major] = encodeMap;
  encoders[Type.tag.major] = encodeTag;
  encoders[Type.float.major] = encodeFloat;
  return encoders;
}
var cborEncoders = makeCborEncoders();
var buf = new Bl();
var Ref = class _Ref {
  /**
   * @param {object|any[]} obj
   * @param {Reference|undefined} parent
   */
  constructor(obj, parent) {
    this.obj = obj;
    this.parent = parent;
  }
  /**
   * @param {object|any[]} obj
   * @returns {boolean}
   */
  includes(obj) {
    let p = this;
    do {
      if (p.obj === obj) {
        return true;
      }
    } while (p = p.parent);
    return false;
  }
  /**
   * @param {Reference|undefined} stack
   * @param {object|any[]} obj
   * @returns {Reference}
   */
  static createCheck(stack, obj) {
    if (stack && stack.includes(obj)) {
      throw new Error(`${encodeErrPrefix} object contains circular references`);
    }
    return new _Ref(obj, stack);
  }
};
var simpleTokens = {
  null: new Token(Type.null, null),
  undefined: new Token(Type.undefined, void 0),
  true: new Token(Type.true, true),
  false: new Token(Type.false, false),
  emptyArray: new Token(Type.array, 0),
  emptyMap: new Token(Type.map, 0)
};
var typeEncoders = {
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  number(obj, _typ, _options, _refStack) {
    if (!Number.isInteger(obj) || !Number.isSafeInteger(obj)) {
      return new Token(Type.float, obj);
    } else if (obj >= 0) {
      return new Token(Type.uint, obj);
    } else {
      return new Token(Type.negint, obj);
    }
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  bigint(obj, _typ, _options, _refStack) {
    if (obj >= BigInt(0)) {
      return new Token(Type.uint, obj);
    } else {
      return new Token(Type.negint, obj);
    }
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  Uint8Array(obj, _typ, _options, _refStack) {
    return new Token(Type.bytes, obj);
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  string(obj, _typ, _options, _refStack) {
    return new Token(Type.string, obj);
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  boolean(obj, _typ, _options, _refStack) {
    return obj ? simpleTokens.true : simpleTokens.false;
  },
  /**
   * @param {any} _obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  null(_obj, _typ, _options, _refStack) {
    return simpleTokens.null;
  },
  /**
   * @param {any} _obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  undefined(_obj, _typ, _options, _refStack) {
    return simpleTokens.undefined;
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  ArrayBuffer(obj, _typ, _options, _refStack) {
    return new Token(Type.bytes, new Uint8Array(obj));
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} _options
   * @param {Reference} [_refStack]
   * @returns {TokenOrNestedTokens}
   */
  DataView(obj, _typ, _options, _refStack) {
    return new Token(Type.bytes, new Uint8Array(obj.buffer, obj.byteOffset, obj.byteLength));
  },
  /**
   * @param {any} obj
   * @param {string} _typ
   * @param {EncodeOptions} options
   * @param {Reference} [refStack]
   * @returns {TokenOrNestedTokens}
   */
  Array(obj, _typ, options, refStack) {
    if (!obj.length) {
      if (options.addBreakTokens === true) {
        return [simpleTokens.emptyArray, new Token(Type.break)];
      }
      return simpleTokens.emptyArray;
    }
    refStack = Ref.createCheck(refStack, obj);
    const entries = [];
    let i = 0;
    for (const e of obj) {
      entries[i++] = objectToTokens(e, options, refStack);
    }
    if (options.addBreakTokens) {
      return [new Token(Type.array, obj.length), entries, new Token(Type.break)];
    }
    return [new Token(Type.array, obj.length), entries];
  },
  /**
   * @param {any} obj
   * @param {string} typ
   * @param {EncodeOptions} options
   * @param {Reference} [refStack]
   * @returns {TokenOrNestedTokens}
   */
  Object(obj, typ, options, refStack) {
    const isMap = typ !== "Object";
    const keys = isMap ? obj.keys() : Object.keys(obj);
    const length = isMap ? obj.size : keys.length;
    if (!length) {
      if (options.addBreakTokens === true) {
        return [simpleTokens.emptyMap, new Token(Type.break)];
      }
      return simpleTokens.emptyMap;
    }
    refStack = Ref.createCheck(refStack, obj);
    const entries = [];
    let i = 0;
    for (const key of keys) {
      entries[i++] = [
        objectToTokens(key, options, refStack),
        objectToTokens(isMap ? obj.get(key) : obj[key], options, refStack)
      ];
    }
    sortMapEntries(entries, options);
    if (options.addBreakTokens) {
      return [new Token(Type.map, length), entries, new Token(Type.break)];
    }
    return [new Token(Type.map, length), entries];
  }
};
typeEncoders.Map = typeEncoders.Object;
typeEncoders.Buffer = typeEncoders.Uint8Array;
for (const typ of "Uint8Clamped Uint16 Uint32 Int8 Int16 Int32 BigUint64 BigInt64 Float32 Float64".split(" ")) {
  typeEncoders[`${typ}Array`] = typeEncoders.DataView;
}
function objectToTokens(obj, options = {}, refStack) {
  const typ = is(obj);
  const customTypeEncoder = options && options.typeEncoders && /** @type {OptionalTypeEncoder} */
  options.typeEncoders[typ] || typeEncoders[typ];
  if (typeof customTypeEncoder === "function") {
    const tokens = customTypeEncoder(obj, typ, options, refStack);
    if (tokens != null) {
      return tokens;
    }
  }
  const typeEncoder = typeEncoders[typ];
  if (!typeEncoder) {
    throw new Error(`${encodeErrPrefix} unsupported type: ${typ}`);
  }
  return typeEncoder(obj, typ, options, refStack);
}
function sortMapEntries(entries, options) {
  if (options.mapSorter) {
    entries.sort(options.mapSorter);
  }
}
function mapSorter(e1, e2) {
  const keyToken1 = Array.isArray(e1[0]) ? e1[0][0] : e1[0];
  const keyToken2 = Array.isArray(e2[0]) ? e2[0][0] : e2[0];
  if (keyToken1.type !== keyToken2.type) {
    return keyToken1.type.compare(keyToken2.type);
  }
  const major = keyToken1.type.major;
  const tcmp = cborEncoders[major].compareTokens(keyToken1, keyToken2);
  if (tcmp === 0) {
    console.warn("WARNING: complex key types used, CBOR key sorting guarantees are gone");
  }
  return tcmp;
}
function tokensToEncoded(buf2, tokens, encoders, options) {
  if (Array.isArray(tokens)) {
    for (const token of tokens) {
      tokensToEncoded(buf2, token, encoders, options);
    }
  } else {
    encoders[tokens.type.major](buf2, tokens, options);
  }
}
function encodeCustom(data, encoders, options) {
  const tokens = objectToTokens(data, options);
  if (!Array.isArray(tokens) && options.quickEncodeToken) {
    const quickBytes = options.quickEncodeToken(tokens);
    if (quickBytes) {
      return quickBytes;
    }
    const encoder = encoders[tokens.type.major];
    if (encoder.encodedSize) {
      const size = encoder.encodedSize(tokens, options);
      const buf2 = new Bl(size);
      encoder(buf2, tokens, options);
      if (buf2.chunks.length !== 1) {
        throw new Error(`Unexpected error: pre-calculated length for ${tokens} was wrong`);
      }
      return asU8A(buf2.chunks[0]);
    }
  }
  buf.reset();
  tokensToEncoded(buf, tokens, encoders, options);
  return buf.toBytes(true);
}
function encode(data, options) {
  options = Object.assign({}, defaultEncodeOptions, options);
  return encodeCustom(data, cborEncoders, options);
}

// src/utils/cborg/lib/decode.js
var defaultDecodeOptions = {
  strict: false,
  allowIndefinite: true,
  allowUndefined: true,
  allowBigInt: true
};
var Tokeniser = class {
  /**
   * @param {Uint8Array} data
   * @param {DecodeOptions} options
   */
  constructor(data, options = {}) {
    this._pos = 0;
    this.data = data;
    this.options = options;
  }
  pos() {
    return this._pos;
  }
  done() {
    return this._pos >= this.data.length;
  }
  next() {
    const byt = this.data[this._pos];
    let token = quick[byt];
    if (token === void 0) {
      const decoder = jump[byt];
      if (!decoder) {
        throw new Error(`${decodeErrPrefix} no decoder for major type ${byt >>> 5} (byte 0x${byt.toString(16).padStart(2, "0")})`);
      }
      const minor = byt & 31;
      token = decoder(this.data, this._pos, minor, this.options);
    }
    this._pos += token.encodedLength;
    return token;
  }
};
var DONE = Symbol.for("DONE");
var BREAK = Symbol.for("BREAK");
function tokenToArray(token, tokeniser, options) {
  const arr = [];
  for (let i = 0; i < token.value; i++) {
    const value = tokensToObject(tokeniser, options);
    if (value === BREAK) {
      if (token.value === Infinity) {
        break;
      }
      throw new Error(`${decodeErrPrefix} got unexpected break to lengthed array`);
    }
    if (value === DONE) {
      throw new Error(`${decodeErrPrefix} found array but not enough entries (got ${i}, expected ${token.value})`);
    }
    arr[i] = value;
  }
  return arr;
}
function tokenToMap(token, tokeniser, options) {
  const useMaps = options.useMaps === true;
  const obj = useMaps ? void 0 : {};
  const m = useMaps ? /* @__PURE__ */ new Map() : void 0;
  for (let i = 0; i < token.value; i++) {
    const key = tokensToObject(tokeniser, options);
    if (key === BREAK) {
      if (token.value === Infinity) {
        break;
      }
      throw new Error(`${decodeErrPrefix} got unexpected break to lengthed map`);
    }
    if (key === DONE) {
      throw new Error(`${decodeErrPrefix} found map but not enough entries (got ${i} [no key], expected ${token.value})`);
    }
    if (useMaps !== true && typeof key !== "string") {
      throw new Error(`${decodeErrPrefix} non-string keys not supported (got ${typeof key})`);
    }
    if (options.rejectDuplicateMapKeys === true) {
      if (useMaps && m.has(key) || !useMaps && key in obj) {
        throw new Error(`${decodeErrPrefix} found repeat map key "${key}"`);
      }
    }
    const value = tokensToObject(tokeniser, options);
    if (value === DONE) {
      throw new Error(`${decodeErrPrefix} found map but not enough entries (got ${i} [no value], expected ${token.value})`);
    }
    if (useMaps) {
      m.set(key, value);
    } else {
      obj[key] = value;
    }
  }
  return useMaps ? m : obj;
}
function tokensToObject(tokeniser, options) {
  if (tokeniser.done()) {
    return DONE;
  }
  const token = tokeniser.next();
  if (token.type === Type.break) {
    return BREAK;
  }
  if (token.type.terminal) {
    return token.value;
  }
  if (token.type === Type.array) {
    return tokenToArray(token, tokeniser, options);
  }
  if (token.type === Type.map) {
    return tokenToMap(token, tokeniser, options);
  }
  if (token.type === Type.tag) {
    if (options.tags && typeof options.tags[token.value] === "function") {
      const tagged = tokensToObject(tokeniser, options);
      return options.tags[token.value](tagged);
    }
    throw new Error(`${decodeErrPrefix} tag not supported (${token.value})`);
  }
  throw new Error("unsupported");
}
function decodeFirst(data, options) {
  if (!(data instanceof Uint8Array)) {
    throw new Error(`${decodeErrPrefix} data to decode must be a Uint8Array`);
  }
  options = Object.assign({}, defaultDecodeOptions, options);
  const tokeniser = options.tokenizer || new Tokeniser(data, options);
  const decoded = tokensToObject(tokeniser, options);
  if (decoded === DONE) {
    throw new Error(`${decodeErrPrefix} did not find any content to decode`);
  }
  if (decoded === BREAK) {
    throw new Error(`${decodeErrPrefix} got unexpected break`);
  }
  return [decoded, data.subarray(tokeniser.pos())];
}
function decode(data, options) {
  const [decoded, remainder] = decodeFirst(data, options);
  if (remainder.length > 0) {
    throw new Error(`${decodeErrPrefix} too many terminals, data makes no sense`);
  }
  return decoded;
}

// src/utils/index.ts
var Utils = class {
  cw3;
  constructor(cw3) {
    this.cw3 = cw3;
  }
  /**
   * Cbor encoding and decoding library
   */
  Cborg = cborg_exports;
  /**
   * Bech32 encoding and decoding library
   */
  Bech32 = Bech32;
  /**
   * Blake2b hashing library
   */
  Blake2b = Blake2b2;
  /**
   * Bip39 mnemonic library (only english words supported)
   */
  Bip39 = bip39_exports;
  /**
   * Buffer polyfill for browser
   */
  Buffer = Buffer4;
  /**
   * Keys related utils
   */
  keys = {
    mnemonicGenerate: (length = 24) => {
      return generateMnemonic(32 * length / 3);
    },
    mnemonicValidate: (mnemonic) => {
      return validateMnemonic(mnemonic);
    },
    mnemonicToXprvKey: (mnemonic, password) => {
      return this.cw3.CML.Bip32PrivateKey.from_bip39_entropy(
        this.misc.fromHex(mnemonicToEntropy(mnemonic)),
        password ? new TextEncoder().encode(password) : new Uint8Array()
      ).to_bech32();
    },
    xprvKeyGenerate: () => {
      return this.cw3.CML.Bip32PrivateKey.generate_ed25519_bip32().to_bech32();
    },
    xprvKeyValidate: (xprvKey) => {
      try {
        this.cw3.CML.Bip32PrivateKey.from_bech32(xprvKey).to_bech32();
        return true;
      } catch {
        return false;
      }
    },
    xprvKeyToXpubKey: (xprvKey, accountPath, addressPath) => {
      let key = this.cw3.CML.Bip32PrivateKey.from_bech32(xprvKey);
      if (accountPath) {
        for (const index of accountPath) {
          key = key.derive(this.misc.harden(index));
        }
      }
      if (addressPath) {
        for (const index of addressPath) {
          key = key.derive(index);
        }
      }
      return key.to_public().to_bech32();
    },
    xprvToVrfKey: (xprvKey, accountPath, addressPath) => {
      let key = this.cw3.CML.Bip32PrivateKey.from_bech32(xprvKey);
      if (accountPath) {
        for (const index of accountPath) {
          key = key.derive(this.misc.harden(index));
        }
      }
      if (addressPath) {
        for (const index of addressPath) {
          key = key.derive(index);
        }
      }
      return key.to_raw_key().to_bech32();
    },
    xvkKeyToXpubKey: (xvkKey) => {
      return Bech32.bech32.encode("xpub", Bech32.bech32.decode(xvkKey, 118).words, 114);
    },
    xpubKeyValidate: (pubKey) => {
      try {
        this.cw3.CML.Bip32PublicKey.from_bech32(pubKey);
        return true;
      } catch {
        return false;
      }
    }
  };
  /**
   * Address related utils
   */
  address = {
    validateAddress: (addrBech32) => {
      try {
        this.cw3.CML.Address.from_bech32(addrBech32);
        return true;
      } catch {
        return false;
      }
    },
    getNetwork: (addrBech32) => {
      try {
        return this.cw3.CML.Address.from_bech32(addrBech32).network_id();
      } catch {
        return void 0;
      }
    },
    deriveBase: (xpubKey, addressDerivationPath) => {
      const paymentKeyHash = this.cw3.CML.Bip32PublicKey.from_bech32(xpubKey).derive(addressDerivationPath[0]).derive(addressDerivationPath[1]).to_raw_key().hash();
      const stakeKeyHash = this.cw3.CML.Bip32PublicKey.from_bech32(xpubKey).derive(2).derive(0).to_raw_key().hash();
      return this.cw3.CML.BaseAddress.new(
        this.cw3.__config.network.id,
        this.cw3.CML.Credential.new_pub_key(paymentKeyHash),
        this.cw3.CML.Credential.new_pub_key(stakeKeyHash)
      ).to_address().to_bech32();
    },
    deriveEnterprise: (xpubKey, addressDerivationPath) => {
      const paymentKeyHash = this.cw3.CML.Bip32PublicKey.from_bech32(xpubKey).derive(addressDerivationPath[0]).derive(addressDerivationPath[1]).to_raw_key().hash();
      return this.cw3.CML.EnterpriseAddress.new(
        this.cw3.__config.network.id,
        this.cw3.CML.Credential.new_pub_key(paymentKeyHash)
      ).to_address().to_bech32();
    },
    deriveStaking: (xpubKey) => {
      const stakeKeyHash = this.cw3.CML.Bip32PublicKey.from_bech32(xpubKey).derive(2).derive(0).to_raw_key().hash();
      return this.cw3.CML.RewardAddress.new(
        this.cw3.__config.network.id,
        this.cw3.CML.Credential.new_pub_key(stakeKeyHash)
      ).to_address().to_bech32();
    },
    getStakingAddress: (addrBech32) => {
      const address = this.cw3.CML.Address.from_bech32(addrBech32);
      const stakingCred = address.staking_cred();
      return this.cw3.CML.RewardAddress.new(address.network_id(), stakingCred).to_address().to_bech32();
    },
    getCredentials: (addrBech32) => {
      const address = this.cw3.CML.Address.from_bech32(addrBech32);
      const kind = address.kind();
      const type = {
        0: "base",
        1: "pointer",
        2: "enterprise",
        3: "reward",
        4: "byron"
      }[kind];
      if (type === "base") {
        return {
          type,
          paymentCred: address.payment_cred()?.kind() === 0 ? {
            type: "key",
            hash: address.payment_cred()?.as_pub_key()?.to_hex()
          } : {
            type: "script",
            hash: address.payment_cred()?.as_script().to_hex()
          },
          stakingCred: address.staking_cred()?.kind() === 0 ? {
            type: "key",
            hash: address.staking_cred()?.as_pub_key()?.to_hex()
          } : {
            type: "script",
            hash: address.staking_cred()?.as_script().to_hex()
          }
        };
      }
      if (type === "pointer") {
        return {
          type,
          paymentCred: address.payment_cred()?.kind() === 0 ? {
            type: "key",
            hash: address.payment_cred()?.as_pub_key()?.to_hex()
          } : {
            type: "script",
            hash: address.payment_cred()?.as_script().to_hex()
          }
        };
      }
      if (type === "enterprise") {
        return {
          type,
          paymentCred: address.payment_cred()?.kind() === 0 ? {
            type: "key",
            hash: address.payment_cred()?.as_pub_key()?.to_hex()
          } : {
            type: "script",
            hash: address.payment_cred()?.as_script().to_hex()
          }
        };
      }
      if (type === "reward") {
        return {
          type,
          stakingCred: address.payment_cred()?.kind() === 0 ? {
            type: "key",
            hash: address.payment_cred()?.as_pub_key()?.to_hex()
          } : {
            type: "script",
            hash: address.payment_cred()?.as_script().to_hex()
          }
        };
      }
      if (type === "byron") {
        return {
          type
        };
      }
    },
    getShelleyOrByronAddress: (addrBech32) => {
      try {
        return this.cw3.CML.Address.from_bech32(addrBech32);
      } catch {
        return this.cw3.CML.ByronAddress.from_base58(addrBech32).to_address();
      }
    }
  };
  /**
   * Account related utils
   */
  account = {
    checksum: (xpubKey) => {
      return walletChecksum(xpubKey);
    },
    getDetailsFromXpub: (xpubKey, addressDerivationPath) => {
      const paymentAddress = this.address.deriveBase(xpubKey, addressDerivationPath);
      const { paymentCred, stakingCred } = this.address.getCredentials(paymentAddress);
      const stakingAddress = this.address.getStakingAddress(paymentAddress);
      return {
        paymentAddress,
        paymentCred: paymentCred.hash,
        stakingAddress,
        stakingCred: stakingCred.hash
      };
    },
    getBalanceFromUtxos: (utxos) => {
      const balance = {
        value: BigInt(0),
        assets: []
      };
      utxos.forEach((utxo) => {
        balance.value += utxo.value;
        utxo.assets.forEach((asset) => {
          const existingAsset = balance.assets.find(
            (a) => a.policyId + a.assetName === asset.policyId + asset.assetName
          );
          if (existingAsset) {
            existingAsset.quantity += asset.quantity;
          } else {
            balance.assets.push({
              ...asset,
              fingerprint: this.asset.getFingerprint(asset.policyId, asset.assetName),
              assetNameAscii: this.asset.assetNameToAssetNameAscii(asset.assetName)
            });
          }
        });
      });
      return balance;
    }
  };
  /**
   * Asset related utils
   */
  asset = {
    getFingerprint: (policyId, assetName) => {
      const readablePart = "asset";
      const hashBuffer = Blake2b2(20).update(new Uint8Array([...Buffer4.from(policyId, "hex"), ...Buffer4.from(assetName || "", "hex")])).digest("binary");
      const words = Bech32.bech32.toWords(hashBuffer);
      const fingerprint = Bech32.bech32.encode(readablePart, words);
      return fingerprint;
    },
    assetNameToAssetNameAscii: (assetName) => {
      return Buffer4.from(assetName, "hex").toString("utf-8");
    }
  };
  /**
   * TX related utils
   */
  tx = {
    createCostModels: (costModels) => {
      return this.cw3.CML.CostModels.from_json(
        JSON.stringify({
          0: costModels.PlutusV1,
          1: costModels.PlutusV2,
          2: costModels.PlutusV3
        })
      );
    },
    getTxBuilder: (protocolParams) => {
      const pp = protocolParams;
      const txBuilderConfig = this.cw3.CML.TransactionBuilderConfigBuilder.new().fee_algo(
        this.cw3.CML.LinearFee.new(BigInt(pp.minFeeA), BigInt(pp.minFeeB), BigInt(pp.minFeeRefScriptCostPerByte))
      ).pool_deposit(BigInt(pp.poolDeposit)).key_deposit(BigInt(pp.keyDeposit)).coins_per_utxo_byte(BigInt(pp.coinsPerUtxoByte)).max_tx_size(pp.maxTxSize).max_value_size(pp.maxValSize).collateral_percentage(pp.collateralPercentage).max_collateral_inputs(pp.maxCollateralInputs).ex_unit_prices(
        this.cw3.CML.ExUnitPrices.new(
          this.cw3.CML.Rational.new(BigInt(pp.priceMem * 1e8), 100000000n),
          this.cw3.CML.Rational.new(BigInt(pp.priceStep * 1e8), 100000000n)
        )
      ).prefer_pure_change(true).cost_models(this.tx.createCostModels(pp.costModels)).build();
      return this.cw3.CML.TransactionBuilder.new(txBuilderConfig);
    },
    assetsToValue: (value, assets) => {
      const multiAsset = this.cw3.CML.MultiAsset.new();
      if (assets) {
        for (const asset of assets) {
          const policyId = this.cw3.CML.ScriptHash.from_hex(asset.policyId);
          const assetName = this.cw3.CML.AssetName.from_raw_bytes(this.misc.fromHex(asset.assetName || ""));
          const policyAssets = multiAsset.get_assets(policyId) ?? this.cw3.CML.MapAssetNameToCoin.new();
          policyAssets.insert(assetName, asset.quantity);
          multiAsset.insert_assets(policyId, policyAssets);
        }
      }
      return this.cw3.CML.Value.new(value || 0n, multiAsset);
    },
    utxoToCore: (utxo) => {
      return this.cw3.CML.TransactionUnspentOutput.new(
        this.tx.utxoToTransactionInput(utxo),
        this.tx.utxoToTransactionOutput(utxo)
      );
    },
    utxoToTransactionInput: (utxo) => {
      return this.cw3.CML.TransactionInput.new(
        this.cw3.CML.TransactionHash.from_hex(utxo.transaction.id),
        BigInt(utxo.index)
      );
    },
    utxoToTransactionOutput: (utxo) => {
      const value = this.tx.assetsToValue(utxo.value, utxo.assets);
      const outputBuilder = this.tx.outputToTransactionOutputBuilder(
        {
          address: utxo.address,
          value: utxo.value,
          assets: utxo.assets
        },
        utxo.datum ? {
          type: utxo.datumType,
          datum: utxo.datum
        } : void 0,
        utxo.script || void 0
      );
      return outputBuilder.next().with_value(value).build().output();
    },
    outputToTransactionOutputBuilder: (output, datum, script) => {
      const address = this.cw3.utils.address.getShelleyOrByronAddress(output.address);
      let outputBuilder = this.cw3.CML.TransactionOutputBuilder.new().with_address(address);
      if (datum) {
        if (datum.type === "inline") {
          const data = this.cw3.CML.PlutusData.from_cbor_hex(datum.datum);
          const datumOption = this.cw3.CML.DatumOption.new_datum(data);
          outputBuilder = outputBuilder.with_data(datumOption);
        }
        if (datum.type === "hash") {
          const data = this.cw3.CML.PlutusData.from_cbor_hex(datum.datum);
          outputBuilder = outputBuilder.with_communication_data(data);
        }
      }
      return script ? outputBuilder.with_reference_script(this.cw3.utils.script.scriptToScriptRef(script)) : outputBuilder;
    },
    discoverOwnUsedTxKeyHashes: (tx, ownKeyHashes, ownUtxos) => {
      const usedKeyHashes = [];
      const body = tx.body();
      const inputs = body.inputs();
      const collaterals = body.collateral_inputs();
      const certs = body.certs();
      const withdrawals = body.withdrawals();
      const signers = body.required_signers();
      const scripts = tx.witness_set().native_scripts();
      if (inputs && inputs.len() > 0) {
        for (let i = 0; i < inputs.len(); i++) {
          const input = inputs.get(i);
          const txId = input.transaction_id().to_hex();
          const txIndex = Number(input.index());
          const utxo = ownUtxos.find((utxo2) => utxo2.transaction.id === txId && utxo2.index === txIndex);
          if (utxo) {
            const { paymentCred } = this.cw3.utils.address.getCredentials(utxo.address);
            usedKeyHashes.push(paymentCred.hash);
          }
        }
      }
      if (collaterals && collaterals.len() > 0) {
        for (let i = 0; i < collaterals.len(); i++) {
          const input = collaterals.get(i);
          const txId = input.transaction_id().to_hex();
          const txIndex = Number(input.index());
          const utxo = ownUtxos.find((utxo2) => utxo2.transaction.id === txId && utxo2.index === txIndex);
          if (utxo) {
            const { paymentCred } = this.cw3.utils.address.getCredentials(utxo.address);
            usedKeyHashes.push(paymentCred.hash);
          }
        }
      }
      if (certs && certs.len() > 0) {
        for (let i = 0; i < certs.len(); i++) {
          const cert = certs.get(i);
          switch (cert.kind()) {
            case 0:
              break;
            case 1: {
              const credential = cert.as_stake_deregistration()?.stake_credential();
              if (credential?.kind() === 0) {
                usedKeyHashes.push(credential.as_pub_key()?.to_hex());
              }
              if (credential?.kind() === 0) {
                usedKeyHashes.push(credential.as_script()?.to_hex());
              }
              break;
            }
            case 2: {
              const credential = cert.as_stake_delegation()?.stake_credential();
              if (credential?.kind() === 0) {
                usedKeyHashes.push(credential.as_pub_key()?.to_hex());
              }
              if (credential?.kind() === 1) {
                usedKeyHashes.push(credential.as_script()?.to_hex());
              }
              break;
            }
            case 3: {
              const poolParams = cert.as_pool_registration()?.pool_params();
              const owners = poolParams?.pool_owners();
              if (!owners) break;
              for (let i2 = 0; i2 < owners.len(); i2++) {
                const keyHash = owners.get(i2).to_hex();
                usedKeyHashes.push(keyHash);
              }
              const operator = poolParams.operator().to_hex();
              usedKeyHashes.push(operator);
              break;
            }
            case 4: {
              const operator = cert.as_pool_retirement()?.pool().to_hex();
              usedKeyHashes.push(operator);
              break;
            }
            case 6: {
              const credential = cert.as_unreg_cert()?.stake_credential();
              if (credential) {
                usedKeyHashes.push(credential.to_cbor_hex());
              }
              break;
            }
            default:
              break;
          }
        }
      }
      if (withdrawals && withdrawals.len() > 0) {
        const rewardAddresses = withdrawals.keys();
        for (let i = 0; i < rewardAddresses.len(); i++) {
          const credential = rewardAddresses.get(i).payment();
          if (credential.kind() === 0) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          if (credential.kind() === 1) {
            usedKeyHashes.push(credential.as_script()?.to_hex());
          }
        }
      }
      if (signers && signers.len() > 0) {
        for (let i = 0; i < signers.len(); i++) {
          usedKeyHashes.push(signers.get(i).to_hex());
        }
      }
      function keyHashFromScript(scripts2) {
        for (let i = 0; i < scripts2.len(); i++) {
          const script = scripts2.get(i);
          if (script.kind() === 0) {
            const keyHash = script.as_script_pubkey()?.ed25519_key_hash().to_hex();
            usedKeyHashes.push(keyHash);
          }
          if (script.kind() === 1) {
            keyHashFromScript(script.as_script_all().native_scripts());
            return;
          }
          if (script.kind() === 2) {
            keyHashFromScript(script.as_script_any().native_scripts());
            return;
          }
          if (script.kind() === 3) {
            keyHashFromScript(script.as_script_n_of_k().native_scripts());
            return;
          }
        }
      }
      if (scripts && scripts.len() > 0) keyHashFromScript(scripts);
      return usedKeyHashes.filter((hash2) => ownKeyHashes.includes(hash2));
    }
  };
  /**
   * Script related utils
   */
  script = {
    scriptToScriptRef: (script) => {
      switch (script.language) {
        case "Native":
          return this.cw3.CML.Script.new_native(this.cw3.CML.NativeScript.from_cbor_hex(script.script));
        case "PlutusV1":
          return this.cw3.CML.Script.new_plutus_v1(
            this.cw3.CML.PlutusV1Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          );
        case "PlutusV2":
          return this.cw3.CML.Script.new_plutus_v2(
            this.cw3.CML.PlutusV2Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          );
        case "PlutusV3":
          return this.cw3.CML.Script.new_plutus_v3(
            this.cw3.CML.PlutusV3Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          );
        default:
          throw new Error("scriptToScriptRef: Wrong script language");
      }
    },
    scriptToAddress: (script, stakeCredential) => {
      const validatorHash = this.script.scriptToScriptHash(script);
      if (stakeCredential) {
        return this.cw3.CML.BaseAddress.new(
          this.cw3.__config.network.id,
          this.cw3.CML.Credential.new_script(this.cw3.CML.ScriptHash.from_hex(validatorHash)),
          stakeCredential.type === "key" ? this.cw3.CML.Credential.new_pub_key(this.cw3.CML.Ed25519KeyHash.from_hex(stakeCredential.hash)) : this.cw3.CML.Credential.new_script(this.cw3.CML.ScriptHash.from_hex(stakeCredential.hash))
        ).to_address().to_bech32(void 0);
      } else {
        return this.cw3.CML.EnterpriseAddress.new(
          this.cw3.__config.network.id,
          this.cw3.CML.Credential.new_script(this.cw3.CML.ScriptHash.from_hex(validatorHash))
        ).to_address().to_bech32(void 0);
      }
    },
    scriptToPlutusScript: (script) => {
      switch (script.language) {
        case "PlutusV1":
          return this.cw3.CML.PlutusScript.from_v1(
            this.cw3.CML.PlutusV1Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          );
        case "PlutusV2":
          return this.cw3.CML.PlutusScript.from_v2(
            this.cw3.CML.PlutusV2Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          );
        case "PlutusV3":
          return this.cw3.CML.PlutusScript.from_v3(
            this.cw3.CML.PlutusV3Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          );
        default:
          throw new Error("scriptToPlutusScript: Wrong script language");
      }
    },
    scriptToScriptHash: (script) => {
      switch (script.language) {
        case "Native":
          return this.cw3.CML.NativeScript.from_cbor_hex(script.script).hash().to_hex();
        case "PlutusV1":
          return this.cw3.CML.PlutusScript.from_v1(
            this.cw3.CML.PlutusV1Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          ).hash().to_hex();
        case "PlutusV2":
          return this.cw3.CML.PlutusScript.from_v2(
            this.cw3.CML.PlutusV2Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          ).hash().to_hex();
        case "PlutusV3":
          return this.cw3.CML.PlutusScript.from_v3(
            this.cw3.CML.PlutusV3Script.from_cbor_hex(this.script.applyDoubleCborEncoding(script.script))
          ).hash().to_hex();
        default:
          throw new Error("scriptToScriptHash: Wrong script language");
      }
    },
    partialPlutusWitness: (script, redeemer) => {
      return this.cw3.CML.PartialPlutusWitness.new(
        this.cw3.CML.PlutusScriptWitness.new_script(script),
        this.cw3.CML.PlutusData.from_cbor_hex(redeemer)
      );
    },
    applyDoubleCborEncoding: (script) => {
      try {
        this.Cborg.decode(this.Cborg.decode(this.misc.fromHex(script)));
        return script;
      } catch {
        return this.misc.toHex(this.Cborg.encode(this.misc.fromHex(script)));
      }
    },
    nativeScriptFromJson: (json) => {
      const parseNativeScript = (json2) => {
        switch (json2.type) {
          case "sig":
            return this.cw3.CML.NativeScript.new_script_pubkey(this.cw3.CML.Ed25519KeyHash.from_hex(json2.keyHash));
          case "before":
            return this.cw3.CML.NativeScript.new_script_invalid_hereafter(BigInt(json2.slot));
          case "after":
            return this.cw3.CML.NativeScript.new_script_invalid_before(BigInt(json2.slot));
          case "all": {
            const nativeList = this.cw3.CML.NativeScriptList.new();
            json2.scripts.map((script2) => nativeList.add(parseNativeScript(script2)));
            return this.cw3.CML.NativeScript.new_script_all(nativeList);
          }
          case "any": {
            const nativeList = this.cw3.CML.NativeScriptList.new();
            json2.scripts.map((script2) => nativeList.add(parseNativeScript(script2)));
            return this.cw3.CML.NativeScript.new_script_any(nativeList);
          }
          case "atLeast": {
            const nativeList = this.cw3.CML.NativeScriptList.new();
            json2.scripts.map((script2) => nativeList.add(parseNativeScript(script2)));
            return this.cw3.CML.NativeScript.new_script_n_of_k(BigInt(json2.required), nativeList);
          }
        }
      };
      const script = {
        language: "Native",
        script: parseNativeScript(json).to_cbor_hex()
      };
      const policyId = this.script.scriptToScriptHash(script);
      return {
        policyId,
        script
      };
    },
    applyParamsToScript: (plutusScript, params, type) => {
      const p = type ? this.cw3.Data.castTo(params, type) : params;
      return this.misc.toHex(
        this.cw3.UPLC.apply_params_to_script(this.misc.fromHex(this.cw3.Data.to(p)), this.misc.fromHex(plutusScript))
      );
    }
  };
  /**
   * Time related utils
   */
  time = {
    unixTimeToSlot: (unixTime) => {
      const { slotConfig } = this.cw3.__config;
      const timePassed = unixTime - slotConfig.zeroTime;
      const slotsPassed = Math.floor(timePassed / slotConfig.slotDuration);
      return slotsPassed + slotConfig.zeroSlot;
    },
    slotToUnixTime: (slot) => {
      const { slotConfig } = this.cw3.__config;
      const msAfterBegin = (slot - slotConfig.zeroSlot) * slotConfig.slotDuration;
      return slotConfig.zeroTime + msAfterBegin;
    }
  };
  /**
   * Miscellaneous utils
   */
  misc = {
    harden: (num) => {
      return 2147483648 + num;
    },
    fromHex: (hex) => {
      return new Uint8Array(Buffer4.from(hex, "hex"));
    },
    toHex: (bytes) => {
      return Buffer4.from(bytes).toString("hex");
    },
    toStringFromHex(hex) {
      return Buffer4.from(hex, "hex").toString();
    },
    fromStringToHex(text) {
      return Buffer4.from(text).toString("hex");
    },
    encryptDataWithPass: (data, password) => {
      return this.cw3.CML.emip3_encrypt_with_password(
        Buffer4.from(password).toString("hex"),
        Buffer4.from(this.misc.randomBytes(32)).toString("hex"),
        Buffer4.from(this.misc.randomBytes(12)).toString("hex"),
        Buffer4.from(data).toString("hex")
      );
    },
    decryptDataWithPass: (data, password) => {
      return Buffer4.from(
        this.cw3.CML.emip3_decrypt_with_password(Buffer4.from(password).toString("hex"), data),
        "hex"
      ).toString();
    },
    randomBytes: (length) => {
      const bytes = new Uint8Array(length);
      for (let i = 0; i < length; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
      return bytes;
    }
  };
};

// src/core/account.ts
var Account = class _Account {
  cw3;
  __config = {
    configVersion: 1,
    type: void 0,
    checksumImage: void 0,
    checksumId: void 0,
    xpubKey: void 0,
    xprvKey: void 0,
    xprvKeyIsEncoded: void 0,
    accountPath: void 0,
    addressPath: void 0,
    paymentAddress: void 0,
    paymentCred: void 0,
    stakingAddress: void 0,
    stakingCred: void 0,
    connector: void 0
  };
  __state = {
    utxos: [],
    balance: {
      value: 0n,
      assets: []
    },
    delegation: null,
    rewards: 0n
  };
  /**
   * Create a new account from mnemonic
   * @param cw3 CardanoWeb3 instance
   * @param mnemonic 24-word mnemonic
   * @param accountPath Account derivation path (e.g. [1852, 1815, 0])
   * @param addressPath Address derivation path (e.g. [0, 0])
   * @returns Account instance
   */
  static fromMnemonic = (cw3, mnemonic, accountPath, addressPath) => {
    const xprvKey = cw3.utils.keys.mnemonicToXprvKey(mnemonic);
    return this.fromXprvKey(cw3, xprvKey, accountPath, addressPath);
  };
  /**
   * Create a new account from xprv key
   * @param cw3 CardanoWeb3 instance
   * @param xprvKey Extended private key
   * @param accountPath Account derivation path (e.g. [1852, 1815, 0])
   * @param addressPath Address derivation path (e.g. [0, 0])
   * @returns Account instance
   */
  static fromXprvKey = (cw3, xprvKey, accountPath, addressPath) => {
    const account = new _Account();
    const xpubKey = cw3.utils.keys.xprvKeyToXpubKey(xprvKey, accountPath);
    const checksum = cw3.utils.account.checksum(xpubKey);
    const accountDetails = cw3.utils.account.getDetailsFromXpub(xpubKey, addressPath);
    account.cw3 = cw3;
    account.__config.accountPath = accountPath;
    account.__config.addressPath = addressPath;
    account.__config.xpubKey = xpubKey;
    account.__config.xprvKey = xprvKey;
    account.__config.type = "xprv";
    account.__config.checksumImage = checksum.checksumImage;
    account.__config.checksumId = checksum.checksumId;
    account.__config = {
      ...account.__config,
      ...accountDetails
    };
    return account;
  };
  /**
   * Create a new account from xpub key (limited functionality)
   * @param cw3 CardanoWeb3 instance
   * @param xpubKey Extended public key
   * @param addressPath Address derivation path (e.g. [0, 0])
   * @returns Account instance
   */
  static fromXpubKey = (cw3, xpubKey, addressPath) => {
    if (!cw3.utils.keys.xpubKeyValidate(xpubKey)) throw new Error("Invalid public key");
    const account = new _Account();
    const checksum = cw3.utils.account.checksum(xpubKey);
    const accountDetails = cw3.utils.account.getDetailsFromXpub(xpubKey, addressPath);
    account.cw3 = cw3;
    account.__config.accountPath = void 0;
    account.__config.addressPath = addressPath;
    account.__config.xpubKey = xpubKey;
    account.__config.xprvKey = void 0;
    account.__config.type = "xpub";
    account.__config.checksumImage = checksum.checksumImage;
    account.__config.checksumId = checksum.checksumId;
    account.__config = {
      ...account.__config,
      ...accountDetails
    };
    return account;
  };
  /**
   * Create a new account from connector
   * @param cw3 CardanoWeb3 instance
   * @param connector Connector instance
   * @returns Account instance
   */
  static fromConnector = async (cw3, connector) => {
    const connectorNetwork = await connector.getNetworkId();
    if (connectorNetwork !== cw3.__config.network.id) throw new Error("Connector network mismatch");
    const account = new _Account();
    const mainAddress = (await connector.getUsedAddresses())?.[0] || (await connector.getUnusedAddresses())?.[0];
    const paymentAddress = cw3.CML.Address.from_hex(mainAddress).to_bech32();
    const { paymentCred, stakingCred } = cw3.utils.address.getCredentials(paymentAddress);
    const stakingAddress = cw3.CML.Address.from_hex((await connector.getRewardAddresses())[0]).to_bech32();
    account.cw3 = cw3;
    account.__config.accountPath = void 0;
    account.__config.addressPath = void 0;
    account.__config.xpubKey = void 0;
    account.__config.xprvKey = void 0;
    account.__config.type = "connector";
    account.__config.checksumImage = void 0;
    account.__config.checksumId = void 0;
    account.__config.paymentAddress = paymentAddress;
    account.__config.paymentCred = paymentCred.hash;
    account.__config.stakingCred = stakingCred.hash;
    account.__config.stakingAddress = stakingAddress;
    account.__config.connector = connector;
    return account;
  };
  /**
   * Create a new account from address
   * @param cw3 CardanoWeb3 instance
   * @param address Bech32 address
   * @returns Account instance
   */
  static fromAddress = (cw3, address) => {
    const account = new _Account();
    const { paymentCred, stakingCred } = cw3.utils.address.getCredentials(address);
    const stakingAddress = cw3.utils.address.getStakingAddress(address);
    account.cw3 = cw3;
    account.__config.accountPath = void 0;
    account.__config.addressPath = void 0;
    account.__config.xpubKey = void 0;
    account.__config.xprvKey = void 0;
    account.__config.type = "address";
    account.__config.checksumImage = void 0;
    account.__config.checksumId = void 0;
    account.__config.paymentAddress = address;
    account.__config.paymentCred = paymentCred.hash;
    account.__config.stakingCred = stakingCred.hash;
    account.__config.stakingAddress = stakingAddress;
    return account;
  };
  // static fromLedgerHW = (cw3: T.CardanoWeb3, path: T.AccountDerivationPath) => {
  //   throw new Error("Not implemented: fromLedgerHW")
  //   if (typeof window === "undefined") throw new Error("fromLedgerHW is only available in the browser")
  //   const account = new Account()
  //   account.cw3 = cw3
  //   account.__config.type = "ledger"
  //   return account
  // }
  // static fromTrezorHW = (cw3: T.CardanoWeb3, path: T.AccountDerivationPath) => {
  //   throw new Error("Not implemented: fromLedgerHW")
  //   if (typeof window === "undefined") throw new Error("fromTrezorHW is only available in the browser")
  //   const account = new Account()
  //   account.cw3 = cw3
  //   account.__config.type = "trezor"
  //   return account
  // }
  /**
   * Import an account from configuration
   * @param cw3 CardanoWeb3 instance
   * @param config Account configuration
   * @returns Account instance
   */
  static importAccount = (cw3, config) => {
    if (config.configVersion === 1) {
      if (config.type === "xprv") {
        const account = new _Account();
        const xpubConfig = this.fromXpubKey(cw3, config.xpubKey, config.addressPath);
        account.cw3 = cw3;
        account.__config = {
          ...xpubConfig.__config,
          type: config.type,
          xprvKey: config.xprvKey,
          xprvKeyIsEncoded: config.xprvKeyIsEncoded,
          accountPath: config.accountPath,
          addressPath: config.addressPath
        };
        return account;
      }
      if (config.type === "xpub") {
        return this.fromXpubKey(cw3, config.xpubKey, config.addressPath);
      }
      if (config.type === "address") {
        return this.fromAddress(cw3, config.paymentAddress);
      }
    }
    throw new Error(`Wrong account type for import. Only "xprv", "xpub", and "address" types are supported`);
  };
  /**
   * Export account configuration
   * @returns Account configuration
   */
  exportAccount = () => {
    return {
      configVersion: this.__config.configVersion,
      type: this.__config.type,
      xpubKey: this.__config.xpubKey,
      xprvKey: this.__config.xprvKey,
      xprvKeyIsEncoded: this.__config.xprvKeyIsEncoded,
      accountPath: this.__config.accountPath,
      addressPath: this.__config.addressPath,
      paymentAddress: this.__config.paymentAddress,
      stakingAddress: this.__config.stakingAddress
    };
  };
  /**
   * Encode key to encrypted state
   * @param password Password to encrypt the key
   * @throws Error if account type is wrong or xprv key is not found
   * @throws Error if account is already encrypted
   * @returns Encoded xprv key
   */
  encodeXprvKey = (password) => {
    if (!this.__config.xprvKey) throw new Error("Wrong account type. No xprv key found");
    if (this.__config.xprvKeyIsEncoded) throw new Error("Account is already encrypted");
    const xprvKey = this.cw3.utils.misc.encryptDataWithPass(this.__config.xprvKey, password);
    return xprvKey;
  };
  /**
   * Encode key to encrypted state and update internal state
   * @param password Password to encrypt the key
   * @returns Encoded xprv key
   */
  encodeAndUpdateXprvKey = (password) => {
    const xprvKey = this.encodeXprvKey(password);
    this.__config.xprvKey = xprvKey;
    this.__config.xprvKeyIsEncoded = true;
    return xprvKey;
  };
  /**
   * Decode key from encrypted state
   * @param password Password to decrypt the key
   * @returns Decoded xprv key
   * @throws Error if account is not encrypted or account type is wrong
   */
  decodeXprvKey = (password) => {
    if (!this.__config.xprvKey || !this.__config.xprvKeyIsEncoded)
      throw new Error("Account is not encrypted or account type is wrong");
    const xprvKey = this.cw3.utils.misc.decryptDataWithPass(this.__config.xprvKey, password);
    return xprvKey;
  };
  /**
   * Decode key from encrypted state and update internal state
   * @param password Password to decrypt the key
   * @returns Decoded xprv key
   */
  decodeAndUpdateXprvKey = (password) => {
    const xprvKey = this.decodeXprvKey(password);
    this.__config.xprvKey = xprvKey;
    this.__config.xprvKeyIsEncoded = false;
    return xprvKey;
  };
  /**
   * Get account state and update internal state
   * @returns Account state
   */
  getState = async () => {
    const utxos = await this.cw3.provider.getUtxosByAddress(this.__config.paymentAddress);
    const delegation = await this.cw3.provider.getDelegation(this.__config.stakingAddress);
    const balance = this.cw3.utils.account.getBalanceFromUtxos(utxos);
    return {
      utxos,
      balance,
      delegation: delegation?.delegation || null,
      rewards: delegation?.rewards
    };
  };
  /**
   * Get account state and update internal state
   * @returns Account state
   */
  getAndUpdateState = async () => {
    const utxos = await this.cw3.provider.getUtxosByAddress(this.__config.paymentAddress);
    const delegation = await this.cw3.provider.getDelegation(this.__config.stakingAddress);
    const balance = this.cw3.utils.account.getBalanceFromUtxos(utxos);
    this.__state = {
      utxos,
      balance,
      delegation: delegation?.delegation || null,
      rewards: delegation?.rewards
    };
    return this.__state;
  };
};

// src/core/connector.ts
var Connector = class _Connector {
  __api;
  /**
   * List available wallets
   * @returns List of available wallets
   */
  static list = async () => {
    if (typeof window === "undefined") throw new Error("Connector is only available in the browser environment");
    return Object.keys(window?.cardano || {}).map((key) => window?.cardano?.[key]?.apiVersion ? key : "").filter((item) => item !== "");
  };
  /**
   * Check if a wallet is enabled
   * @param wallet Wallet name
   * @returns True if wallet is enabled
   */
  static isEnabled = async (wallet) => {
    if (typeof window === "undefined") throw new Error("Connector is only available in the browser environment");
    return await window?.cardano?.[wallet]?.isEnabled() || false;
  };
  /**
   * Initialize a wallet connector
   * @param wallet Wallet name
   * @param extensions Wallet extensions
   * @returns Connector instance
   */
  static init = async (wallet, extensions) => {
    if (typeof window === "undefined") throw new Error("Connector is only available in the browser environment");
    const connector = new _Connector();
    if (!window?.cardano?.[wallet]) throw new Error(`Wallet ${wallet} not found`);
    const api = await window?.cardano?.[wallet].enable(extensions ? { extensions } : void 0);
    connector.__api = api;
    return connector;
  };
  /**
   * Get wallet extensions
   * @returns Wallet extensions
   */
  getExtensions = async () => {
    return await this.__api.getExtensions();
  };
  /**
   * Get wallet network ID
   * @returns Wallet network ID (0 or 1)
   */
  getNetworkId = async () => {
    return await this.__api.getNetworkId();
  };
  /**
   * Get wallet UTXOs
   * @param amount Amount to filter UTXOs
   * @param paginate Pagination options
   * @returns List of UTXOs
   */
  getUtxos = async (amount, paginate) => {
    return await this.__api.getUtxos(amount, paginate);
  };
  /**
   * Get wallet collaterals
   * @returns List of collaterals
   */
  getCollateral = async () => {
    return await this.__api.getCollateral();
  };
  /**
   * Get wallet balance
   * @returns Wallet balance
   */
  getBalance = async () => {
    return await this.__api.getBalance();
  };
  /**
   * Get wallet used addresses
   * @param paginate Pagination options
   * @returns Array of used addresses
   */
  getUsedAddresses = async (paginate) => {
    return await this.__api.getUsedAddresses(paginate);
  };
  /**
   * Get wallet unused addresses
   * @returns Array of unused addresses
   */
  getUnusedAddresses = async () => {
    return await this.__api.getUnusedAddresses();
  };
  /**
   * Get wallet change address
   * @returns Change address
   */
  getChangeAddress = async () => {
    return await this.__api.getChangeAddress();
  };
  /**
   * Get wallet staking addresses
   * @returns Staking addresses
   */
  getRewardAddresses = async () => {
    return await this.__api.getRewardAddresses();
  };
  /**
   * Sign a transaction
   * @param tx Transaction to sign in CBOR format
   * @param partialSign Partial sign flag (boolean)
   * @returns Staking key
   */
  signTx = async (tx, partialSign = false) => {
    return await this.__api.signTx(tx, partialSign);
  };
  /**
   * Sign a message
   * @param addr Address to sign message
   * @param payload Message to sign
   * @returns Signed message
   */
  signData = async (addr, payload) => {
    return await this.__api.signData(addr, payload);
  };
  /**
   * Submit a transaction
   * @param tx Transaction to submit in CBOR format
   * @returns Transaction hash
   */
  submitTx = async (tx) => {
    return await this.__api.submitTx(tx);
  };
};

// src/provider/koios/index.ts
import KoiosClient from "cardano-koios-client";
var KoiosProvider = class {
  client;
  constructor(baseUrl, headers) {
    this.client = KoiosClient(baseUrl, headers);
  }
  getTip = async () => {
    const response = await this.client.GET("/tip", {});
    const tip = response.data?.[0];
    if (tip) {
      return {
        hash: tip.hash,
        epochNo: tip.epoch_no,
        absSlot: tip.abs_slot,
        epochSlot: tip.epoch_slot,
        blockNo: tip.block_no,
        blockTime: tip.block_time
      };
    }
    throw new Error("Error: KoiosProvider.getTip");
  };
  getProtocolParameters = async () => {
    const response = await this.client.GET("/epoch_params", {
      params: {
        query: {
          _epoch_no: void 0,
          limit: "1"
        }
      }
    });
    if (response.data) {
      return koiosProtocolParamsToProtocolParams(response.data[0]);
    }
    throw new Error("Error: KoiosProvider.getProtocolParameters");
  };
  getUtxosByAddresses = async (addresses) => {
    try {
      const utxos = [];
      let hasMore = true;
      while (hasMore) {
        const response = await this.client.POST("/address_utxos", {
          body: {
            _addresses: addresses,
            _extended: true
          }
        });
        if (response.data && response.data.length > 0) {
          utxos.push(...koiosUtxosToUtxos(response.data));
          if (response.data.length < 1e3) {
            hasMore = false;
          }
        } else {
          hasMore = false;
        }
      }
      return utxos;
    } catch {
      throw new Error("Error: KoiosProvider.getUtxosByAddresses");
    }
  };
  getUtxosByAddress = async (address) => {
    return await this.getUtxosByAddresses([address]);
  };
  getUtxoByOutputRef = async (txHash, index) => {
    const response = await this.client.POST("/utxo_info", {
      body: {
        _utxo_refs: [`${txHash}#${index}`],
        _extended: true
      }
    });
    if (response.data) {
      return koiosUtxoToUtxo(response.data[0]);
    }
    throw new Error("Error: KoiosProvider.getUtxoByTxRef");
  };
  resolveUtxoDatumAndScript = async (utxo) => {
    return {
      ...utxo,
      datum: utxo.datumHash ? await this.getDatumByHash(utxo.datumHash) : null,
      script: utxo.scriptHash ? await this.getScriptByHash(utxo.scriptHash) : null
    };
  };
  resolveUtxosDatumAndScript = async (utxos) => {
    return await Promise.all(
      utxos.map(async (utxo) => {
        return await this.resolveUtxoDatumAndScript(utxo);
      })
    );
  };
  getDatumByHash = async (datumHash) => {
    const response = await this.client.POST("/datum_info", {
      body: {
        _datum_hashes: [datumHash]
      }
    });
    if (response.data) {
      return response.data[0]?.bytes;
    }
    throw new Error("Error: KoiosProvider.getDatumByhash");
  };
  getScriptByHash = async (scriptHash) => {
    const response = await this.client.POST("/script_info", {
      body: {
        _script_hashes: [scriptHash]
      }
    });
    if (response.data) {
      return {
        language: koiosPlutusVersionToPlutusVersion(response.data[0]?.type),
        script: response.data[0]?.bytes
      };
    }
    throw new Error("Error: KoiosProvider.getDatumByhash");
  };
  getDelegation = async (stakingAddress) => {
    const response = await this.client.POST("/account_info", {
      body: {
        _stake_addresses: [stakingAddress]
      }
    });
    if (response.data) {
      const delegation = response.data[0];
      return {
        delegation: delegation?.delegated_pool,
        rewards: BigInt(delegation?.rewards_available || 0)
      };
    }
    throw new Error("Error: KoiosProvider.getDelegation");
  };
  evaluateTx = async (tx) => {
    const response = await this.client.POST("/ogmios", {
      headers: {
        "Content-Type": "application/cbor"
      },
      body: {
        jsonrpc: "2.0",
        method: "evaluateTransaction",
        params: { transaction: { cbor: tx } }
      }
    });
    if (response.data) {
      return response.data?.result || [];
    }
    throw new Error("Error: KoiosProvider.evaluateTx");
  };
  observeTx = (txHash, checkInterval = 3e3, maxTime = TTL * 1e3) => {
    const checkTx = async () => {
      const response = await this.client.POST("/tx_status", {
        body: {
          _tx_hashes: [txHash]
        }
      });
      return response.data && response.data[0].num_confirmations > 0;
    };
    return new Promise(async (res) => {
      const resolve = await checkTx();
      if (resolve) return res(true);
      const confirm = setInterval(async () => {
        const resolve2 = await checkTx();
        if (resolve2) {
          clearInterval(confirm);
          return res(true);
        }
      }, checkInterval);
      setTimeout(() => {
        clearInterval(confirm);
        return res(false);
      }, maxTime);
    });
  };
  submitTx = async (tx) => {
    const response = await this.client.POST("/submittx", {
      parseAs: "text",
      headers: {
        "Content-Type": "application/cbor"
      },
      body: tx
    });
    if (response.data) {
      return response.data;
    }
    if (response.error) {
      throw new Error(JSON.stringify(response.error));
    }
    throw new Error("Error: KoiosProvider.submitTx");
  };
  submitAndObserveTx = async (tx, checkInterval = 3e3, maxTime = TTL * 1e3) => {
    const txHash = await this.submitTx(tx);
    return this.observeTx(txHash, checkInterval, maxTime);
  };
};
var koiosUtxoToUtxo = (utxo) => {
  return {
    transaction: {
      id: utxo.tx_hash
    },
    index: utxo.tx_index,
    address: utxo.address,
    value: BigInt(utxo.value),
    assets: koiosAssetsToAssets(utxo.asset_list || []),
    datumHash: utxo.datum_hash || null,
    datumType: utxo.datum_hash ? utxo.inline_datum ? "inline" : "hash" : null,
    scriptHash: utxo.reference_script?.hash || null,
    datum: null,
    script: null
  };
};
var koiosUtxosToUtxos = (utxos) => {
  return utxos.map((utxo) => koiosUtxoToUtxo(utxo));
};
var koiosAssetsToAssets = (assets) => {
  return assets.map((asset) => {
    return {
      policyId: asset.policy_id,
      assetName: asset.asset_name || "",
      quantity: BigInt(asset.quantity),
      decimals: asset.decimals
    };
  });
};
var koiosPlutusVersionToPlutusVersion = (plutusVersion) => {
  switch (plutusVersion) {
    case "plutusV1":
      return "PlutusV1";
    case "plutusV2":
      return "PlutusV2";
    case "plutusV3":
      return "PlutusV3";
    case "timelock":
      return "Native";
    case "multisig":
      return "Native";
    default:
      throw new Error("Invalid Plutus version");
  }
};
var koiosProtocolParamsToProtocolParams = (pp) => {
  return {
    minFeeA: pp.min_fee_a,
    minFeeB: pp.min_fee_b,
    maxTxSize: pp.max_tx_size,
    maxValSize: pp.max_val_size,
    keyDeposit: BigInt(pp.key_deposit),
    poolDeposit: BigInt(pp.pool_deposit),
    priceMem: pp.price_mem,
    priceStep: pp.price_step,
    maxTxExMem: BigInt(pp.max_tx_ex_mem),
    maxTxExSteps: BigInt(pp.max_tx_ex_steps),
    coinsPerUtxoByte: BigInt(pp.coins_per_utxo_size),
    collateralPercentage: pp.collateral_percent,
    maxCollateralInputs: pp.max_collateral_inputs,
    minFeeRefScriptCostPerByte: 15,
    // TODO
    costModels: pp.cost_models
  };
};

// src/explorer/koios.ts
import KoiosClient2 from "cardano-koios-client";
var koios_default = (baseUrl, headers) => {
  return KoiosClient2(baseUrl, headers);
};

// src/explorer/nftcdn.ts
import NftcdnClient from "cardano-nftcdn-client";
var nftcdn_default = (baseUrl, headers) => {
  return NftcdnClient(baseUrl, headers);
};

// src/utils/data/index.ts
import * as TypeBox from "@sinclair/typebox";
var Constr = class {
  index;
  fields;
  constructor(index, fields) {
    this.index = index;
    this.fields = fields;
  }
};
var Data = (cw3) => {
  return {
    // Types
    // Note: Recursive types are not supported (yet)
    Integer: function(options) {
      const integer = TypeBox.Type.Unsafe({ dataType: "integer" });
      if (options) {
        Object.entries(options).forEach(([key, value]) => {
          integer[key] = value;
        });
      }
      return integer;
    },
    Bytes: function(options) {
      const bytes = TypeBox.Type.Unsafe({ dataType: "bytes" });
      if (options) {
        Object.entries(options).forEach(([key, value]) => {
          bytes[key] = value;
        });
      }
      return bytes;
    },
    Boolean: function() {
      return TypeBox.Type.Unsafe({
        anyOf: [
          {
            title: "False",
            dataType: "constructor",
            index: 0,
            fields: []
          },
          {
            title: "True",
            dataType: "constructor",
            index: 1,
            fields: []
          }
        ]
      });
    },
    Any: function() {
      return TypeBox.Type.Unsafe({ description: "Any Data." });
    },
    Array: function(items, options) {
      const array = TypeBox.Type.Array(items);
      replaceProperties(array, { dataType: "list", items });
      if (options) {
        Object.entries(options).forEach(([key, value]) => {
          array[key] = value;
        });
      }
      return array;
    },
    Map: function(keys, values, options) {
      const map = TypeBox.Type.Unsafe({
        dataType: "map",
        keys,
        values
      });
      if (options) {
        Object.entries(options).forEach(([key, value]) => {
          map[key] = value;
        });
      }
      return map;
    },
    /**
     * Object applies by default a PlutusData Constr with index 0.
     * Set 'hasConstr' to false to serialize Object as PlutusData List.
     */
    Object: function(properties, options) {
      const object = TypeBox.Type.Object(properties);
      replaceProperties(object, {
        anyOf: [
          {
            dataType: "constructor",
            index: 0,
            // Will be replaced when using Data.Enum
            fields: Object.entries(properties).map(([title, p]) => ({
              ...p,
              title
            }))
          }
        ]
      });
      object.anyOf[0].hasConstr = typeof options?.hasConstr === "undefined" || options.hasConstr;
      return object;
    },
    Enum: function(items) {
      const union = TypeBox.Type.Union(items);
      replaceProperties(union, {
        anyOf: items.map(
          (item, index) => item.anyOf[0].fields.length === 0 ? {
            ...item.anyOf[0],
            index
          } : {
            dataType: "constructor",
            title: (() => {
              const title = item.anyOf[0].fields[0].title;
              if (title.charAt(0) !== title.charAt(0).toUpperCase()) {
                throw new Error(`Enum '${title}' needs to start with an uppercase letter.`);
              }
              return item.anyOf[0].fields[0].title;
            })(),
            index,
            fields: item.anyOf[0].fields[0].items || item.anyOf[0].fields[0].anyOf[0].fields
          }
        )
      });
      return union;
    },
    /**
     * Tuple is by default a PlutusData List.
     * Set 'hasConstr' to true to apply a PlutusData Constr with index 0.
     */
    Tuple: function(items, options) {
      const tuple = TypeBox.Type.Tuple(items);
      replaceProperties(tuple, {
        dataType: "list",
        items
      });
      if (options) {
        Object.entries(options).forEach(([key, value]) => {
          tuple[key] = value;
        });
      }
      return tuple;
    },
    Literal: function(title) {
      if (title.charAt(0) !== title.charAt(0).toUpperCase()) {
        throw new Error(`Enum '${title}' needs to start with an uppercase letter.`);
      }
      const literal = TypeBox.Type.Literal(title);
      replaceProperties(literal, {
        anyOf: [
          {
            dataType: "constructor",
            title,
            index: 0,
            // Will be replaced in Data.Enum
            fields: []
          }
        ]
      });
      return literal;
    },
    Nullable: function(item) {
      return TypeBox.Type.Unsafe({
        anyOf: [
          {
            title: "Some",
            description: "An optional value.",
            dataType: "constructor",
            index: 0,
            fields: [item]
          },
          {
            title: "None",
            description: "Nothing.",
            dataType: "constructor",
            index: 1,
            fields: []
          }
        ]
      });
    },
    /**
     * Convert PlutusData to Cbor encoded data.
     * Or apply a shape and convert the provided data struct to Cbor encoded data.
     */
    to: (data, type) => to(cw3, data, type),
    /** Convert Cbor encoded data to PlutusData */
    from: (raw, type) => from(cw3, raw, type),
    /**
     * Note Constr cannot be used here.
     * Strings prefixed with '0x' are not UTF-8 encoded.
     */
    fromJson: (json) => fromJson(cw3, json),
    /**
     * Note Constr cannot be used here, also only bytes/integers as Json keys.
     */
    toJson: (plutusData) => toJson(cw3, plutusData),
    void: function() {
      return "d87980";
    },
    castFrom,
    castTo
  };
};
function to(cw3, data, type) {
  function serialize(data2) {
    try {
      if (typeof data2 === "bigint") {
        return cw3.CML.PlutusData.new_integer(cw3.CML.BigInteger.from_str(data2.toString()));
      } else if (typeof data2 === "string") {
        return cw3.CML.PlutusData.new_bytes(cw3.utils.misc.fromHex(data2));
      } else if (data2 instanceof Constr) {
        const { index, fields } = data2;
        const plutusList = cw3.CML.PlutusDataList.new();
        fields.forEach((field) => plutusList.add(serialize(field)));
        return cw3.CML.PlutusData.new_constr_plutus_data(
          cw3.CML.ConstrPlutusData.new(cw3.CML.BigInteger.from_str(index.toString()).as_u64(), plutusList)
        );
      } else if (data2 instanceof Array) {
        const plutusList = cw3.CML.PlutusDataList.new();
        data2.forEach((arg) => plutusList.add(serialize(arg)));
        return cw3.CML.PlutusData.new_list(plutusList);
      } else if (data2 instanceof Map) {
        const plutusMap = cw3.CML.PlutusMap.new();
        for (const [key, value] of data2.entries()) {
          plutusMap.set(serialize(key), serialize(value));
        }
        return cw3.CML.PlutusData.new_map(plutusMap);
      }
      throw new Error("Unsupported type");
    } catch (error) {
      throw new Error("Could not serialize the data: " + error);
    }
  }
  const d = type ? castTo(data, type) : data;
  return serialize(d).to_cbor_hex();
}
function from(cw3, raw, type) {
  function deserialize(data2) {
    if (data2.kind() === 0) {
      const constr = data2.as_constr_plutus_data();
      const l = constr.fields();
      const desL = [];
      for (let i = 0; i < l.len(); i++) {
        desL.push(deserialize(l.get(i)));
      }
      return new Constr(parseInt(constr.alternative().toString()), desL);
    } else if (data2.kind() === 1) {
      const m = data2.as_map();
      const desM = /* @__PURE__ */ new Map();
      const keys = m.keys();
      for (let i = 0; i < keys.len(); i++) {
        desM.set(deserialize(keys.get(i)), deserialize(m.get(keys.get(i))));
      }
      return desM;
    } else if (data2.kind() === 2) {
      const l = data2.as_list();
      const desL = [];
      for (let i = 0; i < l.len(); i++) {
        desL.push(deserialize(l.get(i)));
      }
      return desL;
    } else if (data2.kind() === 3) {
      return BigInt(data2.as_integer().to_str());
    } else if (data2.kind() === 4) {
      return cw3.utils.misc.toHex(data2.as_bytes());
    }
    throw new Error("Unsupported type");
  }
  const data = deserialize(cw3.CML.PlutusData.from_cbor_hex(raw));
  return type ? castFrom(data, type) : data;
}
function fromJson(cw3, json) {
  function toData(json2) {
    if (typeof json2 === "string") {
      return json2.startsWith("0x") ? cw3.utils.misc.toHex(cw3.utils.misc.fromHex(json2.slice(2))) : cw3.utils.misc.fromStringToHex(json2);
    }
    if (typeof json2 === "number") return BigInt(json2);
    if (typeof json2 === "bigint") return json2;
    if (json2 instanceof Array) return json2.map((v) => toData(v));
    if (json2 instanceof Object) {
      const tempMap = /* @__PURE__ */ new Map();
      Object.entries(json2).forEach(([key, value]) => {
        tempMap.set(toData(key), toData(value));
      });
      return tempMap;
    }
    throw new Error("Unsupported type");
  }
  return toData(json);
}
function toJson(cw3, plutusData) {
  function fromData(data) {
    if (typeof data === "bigint" || typeof data === "number" || typeof data === "string" && !isNaN(parseInt(data)) && data.slice(-1) === "n") {
      const bigint = typeof data === "string" ? BigInt(data.slice(0, -1)) : data;
      return parseInt(bigint.toString());
    }
    if (typeof data === "string") {
      try {
        return new TextDecoder(void 0, { fatal: true }).decode(cw3.utils.misc.fromHex(data));
      } catch (_) {
        return "0x" + cw3.utils.misc.toHex(cw3.utils.misc.fromHex(data));
      }
    }
    if (data instanceof Array) return data.map((v) => fromData(v));
    if (data instanceof Map) {
      const tempJson = {};
      data.forEach((value, key) => {
        const convertedKey = fromData(key);
        if (typeof convertedKey !== "string" && typeof convertedKey !== "number") {
          throw new Error("Unsupported type (Note: Only bytes or integers can be keys of a JSON object)");
        }
        tempJson[convertedKey] = fromData(value);
      });
      return tempJson;
    }
    throw new Error("Unsupported type (Note: Constructor cannot be converted to JSON)");
  }
  return fromData(plutusData);
}
function castFrom(data, type) {
  const shape = type;
  if (!shape) throw new Error("Could not type cast data.");
  const shapeType = (shape.anyOf ? "enum" : "") || shape.dataType;
  switch (shapeType) {
    case "integer": {
      if (typeof data !== "bigint") {
        throw new Error("Could not type cast to integer.");
      }
      integerConstraints(data, shape);
      return data;
    }
    case "bytes": {
      if (typeof data !== "string") {
        throw new Error("Could not type cast to bytes.");
      }
      bytesConstraints(data, shape);
      return data;
    }
    case "constructor": {
      if (isVoid(shape)) {
        if (!(data instanceof Constr) || data.index !== 0 || data.fields.length !== 0) {
          throw new Error("Could not type cast to void.");
        }
        return void 0;
      } else if (data instanceof Constr && data.index === shape.index && (shape.hasConstr || shape.hasConstr === void 0)) {
        const fields = {};
        if (shape.fields.length !== data.fields.length) {
          throw new Error("Could not type cast to object. Fields do not match.");
        }
        shape.fields.forEach((field, fieldIndex) => {
          const title = field.title || "wrapper";
          if (/[A-Z]/.test(title[0])) {
            throw new Error("Could not type cast to object. Object properties need to start with a lowercase letter.");
          }
          fields[title] = castFrom(data.fields[fieldIndex], field);
        });
        return fields;
      } else if (data instanceof Array && !shape.hasConstr && shape.hasConstr !== void 0) {
        const fields = {};
        if (shape.fields.length !== data.length) {
          throw new Error("Could not ype cast to object. Fields do not match.");
        }
        shape.fields.forEach((field, fieldIndex) => {
          const title = field.title || "wrapper";
          if (/[A-Z]/.test(title[0])) {
            throw new Error("Could not type cast to object. Object properties need to start with a lowercase letter.");
          }
          fields[title] = castFrom(data[fieldIndex], field);
        });
        return fields;
      }
      throw new Error("Could not type cast to object.");
    }
    case "enum": {
      if (shape.anyOf.length === 1) {
        return castFrom(data, shape.anyOf[0]);
      }
      if (!(data instanceof Constr)) {
        throw new Error("Could not type cast to enum.");
      }
      const enumShape = shape.anyOf.find((entry) => entry.index === data.index);
      if (!enumShape || enumShape.fields.length !== data.fields.length) {
        throw new Error("Could not type cast to enum.");
      }
      if (isBoolean(shape)) {
        if (data.fields.length !== 0) {
          throw new Error("Could not type cast to boolean.");
        }
        switch (data.index) {
          case 0:
            return false;
          case 1:
            return true;
        }
        throw new Error("Could not type cast to boolean.");
      } else if (isNullable(shape)) {
        switch (data.index) {
          case 0: {
            if (data.fields.length !== 1) {
              throw new Error("Could not type cast to nullable object.");
            }
            return castFrom(data.fields[0], shape.anyOf[0].fields[0]);
          }
          case 1: {
            if (data.fields.length !== 0) {
              throw new Error("Could not type cast to nullable object.");
            }
            return null;
          }
        }
        throw new Error("Could not type cast to nullable object.");
      }
      switch (enumShape.dataType) {
        case "constructor": {
          if (enumShape.fields.length === 0) {
            if (/[A-Z]/.test(enumShape.title[0])) {
              return enumShape.title;
            }
            throw new Error("Could not type cast to enum.");
          } else {
            if (!/[A-Z]/.test(enumShape.title)) {
              throw new Error("Could not type cast to enum. Enums need to start with an uppercase letter.");
            }
            if (enumShape.fields.length !== data.fields.length) {
              throw new Error("Could not type cast to enum.");
            }
            const args = enumShape.fields[0].title ? Object.fromEntries(
              enumShape.fields.map((field, index) => [
                field.title,
                castFrom(data.fields[index], field)
              ])
            ) : enumShape.fields.map((field, index) => castFrom(data.fields[index], field));
            return {
              [enumShape.title]: args
            };
          }
        }
      }
      throw new Error("Could not type cast to enum.");
    }
    case "list": {
      if (shape.items instanceof Array) {
        if (data instanceof Constr && data.index === 0 && shape.hasConstr) {
          return data.fields.map((field, index) => castFrom(field, shape.items[index]));
        } else if (data instanceof Array && !shape.hasConstr) {
          return data.map((field, index) => castFrom(field, shape.items[index]));
        }
        throw new Error("Could not type cast to tuple.");
      } else {
        if (!(data instanceof Array)) {
          throw new Error("Could not type cast to array.");
        }
        listConstraints(data, shape);
        return data.map((field) => castFrom(field, shape.items));
      }
    }
    case "map": {
      if (!(data instanceof Map)) {
        throw new Error("Could not type cast to map.");
      }
      mapConstraints(data, shape);
      const map = /* @__PURE__ */ new Map();
      for (const [key, value] of data.entries()) {
        map.set(castFrom(key, shape.keys), castFrom(value, shape.values));
      }
      return map;
    }
    case void 0: {
      return data;
    }
  }
  throw new Error("Could not type cast data.");
}
function castTo(struct, type) {
  const shape = type;
  if (!shape) throw new Error("Could not type cast struct.");
  const shapeType = (shape.anyOf ? "enum" : "") || shape.dataType;
  switch (shapeType) {
    case "integer": {
      if (typeof struct !== "bigint") {
        throw new Error("Could not type cast to integer.");
      }
      integerConstraints(struct, shape);
      return struct;
    }
    case "bytes": {
      if (typeof struct !== "string") {
        throw new Error("Could not type cast to bytes.");
      }
      bytesConstraints(struct, shape);
      return struct;
    }
    case "constructor": {
      if (isVoid(shape)) {
        if (struct !== void 0) {
          throw new Error("Could not type cast to void.");
        }
        return new Constr(0, []);
      } else if (typeof struct !== "object" || struct === null || shape.fields.length !== Object.keys(struct).length) {
        throw new Error("Could not type cast to constructor.");
      }
      const fields = shape.fields.map(
        (field) => castTo(struct[field.title || "wrapper"], field)
      );
      return shape.hasConstr || shape.hasConstr === void 0 ? new Constr(shape.index, fields) : fields;
    }
    case "enum": {
      if (shape.anyOf.length === 1) {
        return castTo(struct, shape.anyOf[0]);
      }
      if (isBoolean(shape)) {
        if (typeof struct !== "boolean") {
          throw new Error("Could not type cast to boolean.");
        }
        return new Constr(struct ? 1 : 0, []);
      } else if (isNullable(shape)) {
        if (struct === null) return new Constr(1, []);
        else {
          const fields = shape.anyOf[0].fields;
          if (fields.length !== 1) {
            throw new Error("Could not type cast to nullable object.");
          }
          return new Constr(0, [castTo(struct, fields[0])]);
        }
      }
      switch (typeof struct) {
        case "string": {
          if (!/[A-Z]/.test(struct[0])) {
            throw new Error("Could not type cast to enum. Enum needs to start with an uppercase letter.");
          }
          const enumIndex = shape.anyOf.findIndex(
            (s) => s.dataType === "constructor" && s.fields.length === 0 && s.title === struct
          );
          if (enumIndex === -1) throw new Error("Could not type cast to enum.");
          return new Constr(enumIndex, []);
        }
        case "object": {
          if (struct === null) throw new Error("Could not type cast to enum.");
          const structTitle = Object.keys(struct)[0];
          if (!/[A-Z]/.test(structTitle)) {
            throw new Error("Could not type cast to enum. Enum needs to start with an uppercase letter.");
          }
          const enumEntry = shape.anyOf.find((s) => s.dataType === "constructor" && s.title === structTitle);
          if (!enumEntry) throw new Error("Could not type cast to enum.");
          const args = struct[structTitle];
          return new Constr(
            enumEntry.index,
            // check if named args
            args instanceof Array ? args.map((item, index) => castTo(item, enumEntry.fields[index])) : enumEntry.fields.map((entry) => {
              const [_, item] = Object.entries(args).find(([title]) => title === entry.title);
              return castTo(item, entry);
            })
          );
        }
      }
      throw new Error("Could not type cast to enum.");
    }
    case "list": {
      if (!(struct instanceof Array)) {
        throw new Error("Could not type cast to array/tuple.");
      }
      if (shape.items instanceof Array) {
        const fields = struct.map((item, index) => castTo(item, shape.items[index]));
        return shape.hasConstr ? new Constr(0, fields) : fields;
      } else {
        listConstraints(struct, shape);
        return struct.map((item) => castTo(item, shape.items));
      }
    }
    case "map": {
      if (!(struct instanceof Map)) {
        throw new Error("Could not type cast to map.");
      }
      mapConstraints(struct, shape);
      const map = /* @__PURE__ */ new Map();
      for (const [key, value] of struct.entries()) {
        map.set(castTo(key, shape.keys), castTo(value, shape.values));
      }
      return map;
    }
    case void 0: {
      return struct;
    }
  }
  throw new Error("Could not type cast struct.");
}
function integerConstraints(integer, shape) {
  if (shape.minimum && integer < BigInt(shape.minimum)) {
    throw new Error(`Integer ${integer} is below the minimum ${shape.minimum}.`);
  }
  if (shape.maximum && integer > BigInt(shape.maximum)) {
    throw new Error(`Integer ${integer} is above the maxiumum ${shape.maximum}.`);
  }
  if (shape.exclusiveMinimum && integer <= BigInt(shape.exclusiveMinimum)) {
    throw new Error(`Integer ${integer} is below the exclusive minimum ${shape.exclusiveMinimum}.`);
  }
  if (shape.exclusiveMaximum && integer >= BigInt(shape.exclusiveMaximum)) {
    throw new Error(`Integer ${integer} is above the exclusive maximum ${shape.exclusiveMaximum}.`);
  }
}
function bytesConstraints(bytes, shape) {
  if (shape.enum && !shape.enum.some((keyword) => keyword === bytes))
    throw new Error(`None of the keywords match with '${bytes}'.`);
  if (shape.minLength && bytes.length / 2 < shape.minLength) {
    throw new Error(`Bytes need to have a length of at least ${shape.minLength} bytes.`);
  }
  if (shape.maxLength && bytes.length / 2 > shape.maxLength) {
    throw new Error(`Bytes can have a length of at most ${shape.minLength} bytes.`);
  }
}
function listConstraints(list, shape) {
  if (shape.minItems && list.length < shape.minItems) {
    throw new Error(`Array needs to contain at least ${shape.minItems} items.`);
  }
  if (shape.maxItems && list.length > shape.maxItems) {
    throw new Error(`Array can contain at most ${shape.maxItems} items.`);
  }
  if (shape.uniqueItems && new Set(list).size !== list.length) {
    throw new Error("Array constains duplicates.");
  }
}
function mapConstraints(map, shape) {
  if (shape.minItems && map.size < shape.minItems) {
    throw new Error(`Map needs to contain at least ${shape.minItems} items.`);
  }
  if (shape.maxItems && map.size > shape.maxItems) {
    throw new Error(`Map can contain at most ${shape.maxItems} items.`);
  }
}
function isBoolean(shape) {
  return shape.anyOf && shape.anyOf[0]?.title === "False" && shape.anyOf[1]?.title === "True";
}
function isVoid(shape) {
  return shape.index === 0 && shape.fields.length === 0;
}
function isNullable(shape) {
  return shape.anyOf && shape.anyOf[0]?.title === "Some" && shape.anyOf[1]?.title === "None";
}
function replaceProperties(object, properties) {
  Object.keys(object).forEach((key) => {
    delete object[key];
  });
  Object.assign(object, properties);
}

// src/utils/message/index.ts
var Message = (cw3) => {
  return {
    signData: (addressHex, payload, privateKey) => {
      const M = cw3.MSL;
      const C = cw3.CML;
      const { fromHex, toHex: toHex2 } = cw3.utils.misc;
      const protectedHeaders = M.HeaderMap.new();
      protectedHeaders.set_algorithm_id(M.Label.from_algorithm_id(M.AlgorithmId.EdDSA));
      protectedHeaders.set_header(M.Label.new_text("address"), M.CBORValue.new_bytes(fromHex(addressHex)));
      const protectedSerialized = M.ProtectedHeaderMap.new(protectedHeaders);
      const unprotectedHeaders = M.HeaderMap.new();
      const headers = M.Headers.new(protectedSerialized, unprotectedHeaders);
      const builder = M.COSESign1Builder.new(headers, fromHex(payload), false);
      const toSign = builder.make_data_to_sign().to_bytes();
      const priv = C.PrivateKey.from_bech32(privateKey);
      const signedSigStruc = priv.sign(toSign).to_raw_bytes();
      const coseSign1 = builder.build(signedSigStruc);
      const key = M.COSEKey.new(
        M.Label.from_key_type(M.KeyType.OKP)
        //OKP
      );
      key.set_algorithm_id(M.Label.from_algorithm_id(M.AlgorithmId.EdDSA));
      key.set_header(
        M.Label.new_int(M.Int.new_negative(M.BigNum.from_str("1"))),
        M.CBORValue.new_int(
          M.Int.new_i32(6)
          //M.CurveType.Ed25519
        )
      );
      key.set_header(
        M.Label.new_int(M.Int.new_negative(M.BigNum.from_str("2"))),
        M.CBORValue.new_bytes(priv.to_public().to_raw_bytes())
      );
      return {
        signature: toHex2(coseSign1.to_bytes()),
        key: toHex2(key.to_bytes())
      };
    },
    verifyData: (addressHex, keyHash, payload, signedMessage) => {
      const M = cw3.MSL;
      const C = cw3.CML;
      const { fromHex, toHex: toHex2 } = cw3.utils.misc;
      const cose1 = M.COSESign1.from_bytes(fromHex(signedMessage.signature));
      const key = M.COSEKey.from_bytes(fromHex(signedMessage.key));
      const protectedHeaders = cose1.headers().protected().deserialized_headers();
      const cose1Address = (() => {
        try {
          return toHex2(protectedHeaders.header(M.Label.new_text("address"))?.as_bytes());
        } catch (_e) {
          throw new Error("No address found in signature.");
        }
      })();
      const cose1AlgorithmId = (() => {
        try {
          const int = protectedHeaders.algorithm_id()?.as_int();
          if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
          return parseInt(int?.as_negative()?.to_str());
        } catch (_e) {
          throw new Error("Failed to retrieve Algorithm Id.");
        }
      })();
      const keyAlgorithmId = (() => {
        try {
          const int = key.algorithm_id()?.as_int();
          if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
          return parseInt(int?.as_negative()?.to_str());
        } catch (_e) {
          throw new Error("Failed to retrieve Algorithm Id.");
        }
      })();
      const keyCurve = (() => {
        try {
          const int = key.header(M.Label.new_int(M.Int.new_negative(M.BigNum.from_str("1"))))?.as_int();
          if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
          return parseInt(int?.as_negative()?.to_str());
        } catch (_e) {
          throw new Error("Failed to retrieve Curve.");
        }
      })();
      const keyType = (() => {
        try {
          const int = key.key_type().as_int();
          if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
          return parseInt(int?.as_negative()?.to_str());
        } catch (_e) {
          throw new Error("Failed to retrieve Key Type.");
        }
      })();
      const publicKey = (() => {
        try {
          return C.PublicKey.from_bytes(
            key.header(M.Label.new_int(M.Int.new_negative(M.BigNum.from_str("2"))))?.as_bytes()
          );
        } catch (_e) {
          throw new Error("No public key found.");
        }
      })();
      const cose1Payload = (() => {
        try {
          return toHex2(cose1.payload());
        } catch (_e) {
          throw new Error("No payload found.");
        }
      })();
      const signature = C.Ed25519Signature.from_raw_bytes(cose1.signature());
      const data = cose1.signed_data(void 0, void 0).to_bytes();
      if (cose1Address !== addressHex) return false;
      if (keyHash !== publicKey.hash().to_hex()) return false;
      if (cose1AlgorithmId !== keyAlgorithmId && cose1AlgorithmId !== M.AlgorithmId.EdDSA) {
        return false;
      }
      if (keyCurve !== 6) return false;
      if (keyType !== 1) return false;
      if (cose1Payload !== payload) return false;
      return publicKey.verify(data, signature);
    }
  };
};

// src/core/cw3.ts
var CardanoWeb3 = class _CardanoWeb3 {
  /** dcSpark @ Cardano Multiplatform Library */
  CML;
  /** Emurgo @ Message Signing Library */
  MSL;
  /** UPLC @ Untyped Plutus Core Library */
  UPLC;
  // /** Lucid Plutus Data Serialization Lib */
  Data;
  /** Lucid Plutus Data Construction Lib */
  Constr;
  /** Message Signing/Verification Lib */
  Message;
  explorer;
  provider;
  utils;
  __config;
  /**
   * Initialize CardanoWeb3 library
   * @param config Configuration object
   * @returns CardanoWeb3 instance
   */
  static init = async (config) => {
    const cw3 = new _CardanoWeb3();
    const network = config?.network || "mainnet";
    cw3.CML = await import("@dcspark/cardano-multiplatform-lib-nodejs");
    cw3.MSL = await import("@emurgo/cardano-message-signing-nodejs");
    cw3.UPLC = await import("uplc-node");
    cw3.Data = Data(cw3);
    cw3.Constr = Constr;
    cw3.Message = Message(cw3);
    cw3.explorer = {
      koios: koios_default(
        config?.explorer?.koios?.url || `https://graph.xray.app/output/koios/${network}/api/v1`,
        config?.explorer?.koios?.headers
      ),
      nftcdn: nftcdn_default(
        config?.explorer?.nftcdn?.url || `https://graph.xray.app/output/nftcdn/${network}/api/v1`,
        config?.explorer?.nftcdn?.headers
      )
      // TODO: Not available yet
      // pricing: PricingExplorer(
      //   config?.explorer?.pricing?.url || `https://graph.xray.app/output/pricing/mainnet/api/v1`,
      //   config?.explorer?.pricing?.headers
      // ),
    };
    cw3.provider = config?.provider || new KoiosProvider(`https://graph.xray.app/output/koios/${network}/api/v1`);
    cw3.utils = new Utils(cw3);
    cw3.__config = {
      network: {
        name: network,
        type: network === "mainnet" ? "mainnet" : "testnet",
        id: network === "mainnet" ? 1 : 0
      },
      protocolParams: config?.protocolParams || DEFAULT_PROTOCOL_PARAMETERS,
      slotConfig: config?.slotConfig || SLOT_CONFIG_NETWORK[network],
      ttl: config?.ttl || TTL
    };
    return cw3;
  };
  connector = {
    /**
     * List available wallet connectors
     * @returns List of available connectors in window object
     */
    list: async () => {
      return await Connector.list();
    },
    /**
     * Check if wallet connector is enabled
     * @param wallet Wallet name
     * @returns True if wallet is enabled, false otherwise
     */
    isEnabled: async (wallet) => {
      return await Connector.isEnabled(wallet);
    },
    /**
     * Initialize wallet connector
     * @param wallet Wallet name
     * @param extensions Wallet extensions
     * @returns Wallet connector instance
     */
    init: async (wallet, extensions) => {
      return await Connector.init(wallet, extensions);
    }
  };
  account = {
    /**
     * Create new account from mnemonic
     * @param mnemonic Mnemonic
     * @param accountPath Account derivation path
     * @param addressPath Address derivation path
     * @returns Account instance
     */
    fromMnemonic: (mnemonic, accountPath = DEFAULT_ACCOUNT_DERIVATION_PATH, addressPath = DEFAULT_ADDRESS_DERIVATION_PATH) => {
      return Account.fromMnemonic(this, mnemonic, accountPath, addressPath);
    },
    /**
     * Create new account from xprv key
     * @param xprvKey Extended private key
     * @param accountPath Account derivation path (optioanl, default: [1852, 1815, 0])
     * @param addressPath Address derivation path (optional, default: [0, 0])
     * @returns Account instance
     */
    fromXprvKey: (xprvKey, accountPath = DEFAULT_ACCOUNT_DERIVATION_PATH, addressPath = DEFAULT_ADDRESS_DERIVATION_PATH) => {
      return Account.fromXprvKey(this, xprvKey, accountPath, addressPath);
    },
    /**
     * Create new account from xpub key
     * @param xpubKey Extended public key
     * @param addressPath  Known Address derivation path (optional, default: [0, 0])
     * @returns Account instance
     */
    fromXpubKey: (xpubKey, addressPath = DEFAULT_ADDRESS_DERIVATION_PATH) => {
      return Account.fromXpubKey(this, xpubKey, addressPath);
    },
    /**
     * Create new account from wallet connector
     * @param connector Connector instance
     * @returns Account instance
     */
    fromConnector: (connector) => {
      return Account.fromConnector(this, connector);
    },
    /**
     * Create a new account from address
     * @param address Bech32 address
     * @returns Account instance
     */
    fromAddress: (address) => {
      return Account.fromAddress(this, address);
    },
    // fromLedgerHW: (path: T.AccountDerivationPath = DEFAULT_ACCOUNT_DERIVATION_PATH) => {
    //   return Account.fromLedgerHW(this, path)
    // },
    // fromTrezorHW: (path: T.AccountDerivationPath = DEFAULT_ACCOUNT_DERIVATION_PATH) => {
    //   return Account.fromTrezorHW(this, path)
    // },
    /**
     * Import account from JSON config
     * @param config Account export config
     * @returns Account instance
     */
    importAccount: (config) => {
      return Account.importAccount(this, config);
    }
  };
  /**
   * Generate new transaction builder
   * @returns Transaction builder instance
   */
  createTx = () => {
    return new TxBuilder(this);
  };
  /**
   * Import transaction from CBOR string
   * @param tx Transaction JSON
   * @returns Transaction finalizer instance
   */
  importTx = (tx) => {
    return new TxFinalizer(this, tx);
  };
  /**
   * Submit transaction to blockchain
   * @param tx CBOR encoded transaction
   * @returns Transaction hash
   */
  submitTx = async (tx) => {
    return await this.provider.submitTx(tx);
  };
  /**
   * Observe transaction
   * @param txHash Transaction hash
   * @param checkInterval Check interval in ms
   * @param maxTime Maximum time to wait in ms
   * @returns Transaction status (boolean)
   */
  observeTx = async (txHash, checkInterval, maxTime) => {
    return await this.provider.observeTx(txHash, checkInterval, maxTime);
  };
  /**
   * Submit and observe transaction
   * @param tx CBOR encoded transaction
   * @returns Transaction status (boolean)
   */
  submitAndObserveTx = async (tx) => {
    return await this.provider.submitAndObserveTx(tx);
  };
  /**
   * Generate new Natice Script for token minting
   * @param json Native token config
   * @returns Native token instance
   */
  createNativeScript = (json) => {
    return this.utils.script.nativeScriptFromJson(json);
  };
  /**
   * Sign message with account private key
   * @param account Account instance
   * @param message Message to sign
   * @param password Password for xprv key (optional)
   * @returns Signed message
   */
  signMessageWithAccount = async (account, message, password) => {
    if (account.__config.type === "xprv") {
      if (account.__config.xprvKeyIsEncoded && !password)
        throw new Error("Password is required to sign with xprv encoded account");
      const xprvKey = account.__config.xprvKeyIsEncoded ? account.decodeXprvKey(password) : account.__config.xprvKey;
      const verificationKey = this.utils.keys.xprvToVrfKey(
        xprvKey,
        account.__config.accountPath,
        account.__config.addressPath
      );
      return this.signMessageWithVrfKey(verificationKey, account.__config.paymentAddress, message);
    }
    if (account.__config.type === "xpub") {
      throw new Error("Can't sign TX with xpub account type");
    }
    if (account.__config.type === "connector") {
      const hexAddress = this.CML.Address.from_bech32(account.__config.paymentAddress).to_hex();
      const hexMessage = this.utils.misc.fromStringToHex(message);
      return await account.__config.connector.signData(hexAddress, hexMessage);
    }
    if (account.__config.type === "ledger") {
      throw new Error("Ledger account signing is not implemented yet");
    }
    if (account.__config.type === "trezor") {
      throw new Error("Trezor account signing is not implemented yet");
    }
  };
  /**
   * Sign message with payment key
   * @param verificationKey Payment key
   * @param address Payment address
   * @param message Message to sign
   * @returns Signed message
   */
  signMessageWithVrfKey = (verificationKey, address, message) => {
    const hexAddress = this.CML.Address.from_bech32(address).to_hex();
    const hexMessage = this.utils.misc.fromStringToHex(message);
    const { paymentCred } = this.utils.address.getCredentials(address);
    const hash2 = this.CML.PrivateKey.from_bech32(verificationKey).to_public().hash().to_hex();
    if (!paymentCred?.hash || paymentCred?.hash !== hash2) throw new Error("Verification key does not match the address");
    return this.Message.signData(hexAddress, hexMessage, verificationKey);
  };
  /**
   * Verify signed message
   * @param address Payment address
   * @param message Message to verify
   * @param signedMessage Signed message
   * @returns True if message is verified, false otherwise
   */
  verifyMessage = (address, message, signedMessage) => {
    const hexAddress = this.CML.Address.from_bech32(address).to_hex();
    const hexMessage = this.utils.misc.fromStringToHex(message);
    const { paymentCred, stakingCred } = this.utils.address.getCredentials(address);
    const hash2 = paymentCred?.hash || stakingCred?.hash;
    if (!hash2) throw new Error("Invalid address");
    return this.Message.verifyData(hexAddress, hash2, hexMessage, signedMessage);
  };
  /**
   * Get current tip
   * @returns Current tip object
   */
  tip = async () => {
    return await this.provider.getTip();
  };
};

// src/provider/kupmios/index.ts
var KupmiosProvider = class {
  ogmiosUrl;
  ogmiosHeaders;
  kupoUrl;
  kupoHeaders;
  constructor({
    ogmiosUrl,
    ogmiosHeaders,
    kupoUrl,
    kupoHeaders
  }) {
    this.ogmiosUrl = ogmiosUrl;
    this.ogmiosHeaders = ogmiosHeaders;
    this.kupoUrl = kupoUrl;
    this.kupoHeaders = kupoHeaders;
  }
  getTip = async () => {
    const response = await fetch(`${this.ogmiosUrl}/health`);
    if (response.ok) {
      const tip = await response.json();
      return {
        hash: tip.lastKnownTip.id,
        epochNo: tip.currentEpoch,
        absSlot: tip.lastKnownTip.slot,
        epochSlot: tip.slotInEpoch,
        blockNo: tip.lastKnownTip.height,
        blockTime: Math.floor(new Date(tip.lastTipUpdate).getTime() / 1e3)
      };
    }
    throw new Error("Error: KupmiosProvider.getTip");
  };
  getProtocolParameters = async () => {
    const response = await fetch(`${this.ogmiosUrl}`, {
      method: "POST",
      headers: this.ogmiosHeaders,
      body: JSON.stringify({
        jsonrpc: "2.0",
        method: "queryLedgerState/protocolParameters"
      })
    });
    if (response.ok) {
      const data = await response.json();
      return ogmiosProtocolParametersToProtocolParameters(data.result);
    }
    throw new Error("Error: KupmiosProvider.getProtocolParameters");
  };
  getUtxosByAddresses = async (addresses) => {
    try {
      const utxos = [];
      for (const address of addresses) {
        const response = await fetch(`${this.kupoUrl}/matches/${address}?unspent`, {
          headers: this.kupoHeaders
        });
        if (response.ok) {
          const data = await response.json();
          utxos.push(...kupoUtxosToUtxos(data));
        }
      }
      return utxos;
    } catch {
      throw new Error("Error: KupmiosProvider.getUtxosByAddresses");
    }
  };
  getUtxosByAddress = async (address) => {
    return await this.getUtxosByAddresses([address]);
  };
  getUtxoByOutputRef = async (txHash, index) => {
    const response = await fetch(`${this.kupoUrl}/matches/${index}@${txHash}?unspent`, {
      headers: this.kupoHeaders
    });
    if (response.ok) {
      const data = await response.json();
      return kupoUtxoToUtxo(data[0]);
    }
    throw new Error("Error: KupmiosProvider.getUtxoByTxRef");
  };
  resolveUtxoDatumAndScript = async (utxo) => {
    return {
      ...utxo,
      datum: utxo.datumHash ? await this.getDatumByHash(utxo.datumHash) : null,
      script: utxo.scriptHash ? await this.getScriptByHash(utxo.scriptHash) : null
    };
  };
  resolveUtxosDatumAndScript = async (utxos) => {
    return await Promise.all(
      utxos.map(async (utxo) => {
        return await this.resolveUtxoDatumAndScript(utxo);
      })
    );
  };
  getDatumByHash = async (datumHash) => {
    const response = await fetch(`${this.kupoUrl}/datums/${datumHash}`, {
      headers: this.kupoHeaders
    });
    if (response.ok) {
      const data = await response.json();
      return data?.datum;
    }
    throw new Error("Error: KupmiosProvider.getDatumByhash");
  };
  getScriptByHash = async (scriptHash) => {
    const response = await fetch(`${this.kupoUrl}/scripts/${scriptHash}`, {
      headers: this.kupoHeaders
    });
    if (response.ok) {
      const data = await response.json();
      return {
        language: kupoPlutusVersionToPlutusVersion(data?.language),
        script: data?.script
      };
    }
    throw new Error("Error: KupmiosProvider.getDatumByhash");
  };
  getDelegation = async (stakingAddress) => {
    const response = await fetch(`${this.ogmiosUrl}`, {
      method: "POST",
      headers: this.ogmiosHeaders,
      body: JSON.stringify({
        jsonrpc: "2.0",
        method: "queryLedgerState/rewardAccountSummaries",
        params: {
          keys: [stakingAddress]
        }
      })
    });
    if (response.ok) {
      const data = await response.json();
      const delegation = Object.values(data.result || {})?.[0];
      return {
        delegation: delegation?.delegate?.id,
        rewards: BigInt(delegation?.rewards?.ada?.lovelace || 0)
      };
    }
    throw new Error("Error: KupmiosProvider.getDelegation");
  };
  evaluateTx = async (tx) => {
    const response = await fetch(`${this.ogmiosUrl}`, {
      method: "POST",
      headers: this.ogmiosHeaders,
      body: JSON.stringify({
        jsonrpc: "2.0",
        method: "evaluateTransaction",
        params: { transaction: { cbor: tx } }
      })
    });
    if (response.ok) {
      return (await response.json())?.result || [];
    }
    throw new Error("Error: KupmiosProvider.evaluateTx");
  };
  observeTx = (txHash, checkInterval = 3e3, maxTime = TTL * 1e3) => {
    const checkTx = async () => {
      const response = await fetch(`${this.kupoUrl}/matches/*@${txHash}?unspent`, {
        headers: this.kupoHeaders
      });
      if (response.ok) {
        const data = await response.json();
        return data.length > 0;
      } else {
        return false;
      }
    };
    return new Promise(async (res) => {
      const resolve = await checkTx();
      if (resolve) return res(true);
      const confirm = setInterval(async () => {
        const resolve2 = await checkTx();
        if (resolve2) {
          clearInterval(confirm);
          return res(true);
        }
      }, checkInterval);
      setTimeout(() => {
        clearInterval(confirm);
        return res(false);
      }, maxTime);
    });
  };
  submitTx = async (tx) => {
    const response = await fetch(`${this.ogmiosUrl}`, {
      method: "POST",
      headers: this.ogmiosHeaders,
      body: JSON.stringify({
        jsonrpc: "2.0",
        method: "submitTransaction",
        params: {
          transaction: {
            cbor: tx
          }
        }
      })
    });
    if (response.ok) {
      const data = await response.json();
      return data?.result?.transaction?.id;
    }
    if (!response.ok) {
      const data = await response.json();
      throw new Error(JSON.stringify(data.error));
    }
    throw new Error("Error: KupmiosProvider.submitTx");
  };
  submitAndObserveTx = async (tx, checkInterval = 3e3, maxTime = TTL * 1e3) => {
    const txHash = await this.submitTx(tx);
    return this.observeTx(txHash, checkInterval, maxTime);
  };
};
var kupoUtxoToUtxo = (utxo) => {
  return {
    transaction: {
      id: utxo.transaction_id
    },
    index: utxo.output_index,
    address: utxo.address,
    value: BigInt(utxo.value.coins),
    assets: kupoAssetsToAssets(utxo.value.assets || {}),
    datumHash: utxo.datum_hash || null,
    datumType: utxo.datum_hash ? utxo.datum_type === "hash" ? "hash" : "inline" : null,
    scriptHash: utxo.script_hash || null,
    datum: null,
    script: null
  };
};
var kupoUtxosToUtxos = (utxos) => {
  return utxos.map((utxo) => kupoUtxoToUtxo(utxo));
};
var kupoAssetsToAssets = (assets) => {
  return Object.entries(assets).map(([id, quantity]) => {
    const [policy_id, asset_name] = id.split(".");
    return {
      policyId: policy_id,
      assetName: asset_name || "",
      quantity: BigInt(quantity)
    };
  });
};
var kupoPlutusVersionToPlutusVersion = (plutusVersion) => {
  switch (plutusVersion) {
    case "plutus:v1":
      return "PlutusV1";
    case "plutus:v2":
      return "PlutusV2";
    case "plutus:v3":
      return "PlutusV3";
    case "native":
      return "Native";
    default:
      throw new Error("Invalid Plutus version");
  }
};
var ogmiosProtocolParametersToProtocolParameters = (pp) => {
  const scriptExecutionPricesMemory = pp.scriptExecutionPrices.memory.split("/");
  const scriptExecutionPricesCpu = pp.scriptExecutionPrices.cpu.split("/");
  return {
    minFeeA: parseInt(pp.minFeeCoefficient),
    minFeeB: parseInt(pp.minFeeConstant.ada.lovelace),
    maxTxSize: parseInt(pp.maxTransactionSize.bytes),
    maxValSize: parseInt(pp.maxValueSize.bytes),
    keyDeposit: BigInt(pp.stakeCredentialDeposit.ada.lovelace),
    poolDeposit: BigInt(pp.stakePoolDeposit.ada.lovelace),
    priceMem: parseInt(scriptExecutionPricesMemory[0]) / parseInt(scriptExecutionPricesMemory[1]),
    priceStep: parseInt(scriptExecutionPricesCpu[0]) / parseInt(scriptExecutionPricesCpu[1]),
    maxTxExMem: BigInt(pp.maxExecutionUnitsPerTransaction.memory),
    maxTxExSteps: BigInt(pp.maxExecutionUnitsPerTransaction.cpu),
    coinsPerUtxoByte: BigInt(pp.minUtxoDepositCoefficient),
    collateralPercentage: parseInt(pp.collateralPercentage),
    maxCollateralInputs: parseInt(pp.maxCollateralInputs),
    minFeeRefScriptCostPerByte: 15,
    // TODO
    costModels: {
      PlutusV1: pp.plutusCostModels["plutus:v1"],
      PlutusV2: pp.plutusCostModels["plutus:v2"],
      PlutusV3: pp.plutusCostModels["plutus:v3"]
    }
  };
};
export {
  CardanoWeb3,
  KoiosProvider,
  KupmiosProvider
};
